import {
  ACCOUNTING_SERVICES_INDUSTRY_GROUP,
  ACTIVITIES_RELATED_TO_CREDIT_INTERMEDIATION_INDUSTRY_GROUP,
  ACTIVITIES_RELATED_TO_REAL_ESTATE_INDUSTRY_GROUP,
  ADVERTISING_SERVICES_INDUSTRY_GROUP,
  AEROSPACE_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
  AGENCIES_BROKERAGES_INDUSTRY_GROUP,
  AGRICULTURE_CONSTRUCTION_MANUFACTURING_INDUSTRY_GROUP,
  ALUMINA_AND_ALUMINUM_PRODUCTION_INDUSTRY_GROUP,
  AMUSEMENT_PARKS_INDUSTRY_GROUP,
  ANIMAL_FOOD_MANUFACTURING_INDUSTRY_GROUP,
  ANIMAL_SLAUGHTERING_INDUSTRY_GROUP,
  APPAREL_ACCESSORIES_INDUSTRY_GROUP,
  APPAREL_KNITTING_MILLS_INDUSTRY_GROUP,
  APPAREL_PIECE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
  AQUACULTURE_INDUSTRY_GROUP,
  ARCHITECTURAL_METALS_MANUFACTURING_INDUSTRY_GROUP,
  ARCHITECTURAL_SERVICES_INDUSTRY_GROUP,
  ARTISTS_AGENTS_AND_MANAGERS_INDUSTRY_GROUP,
  AUDIO_VIDEO_MANUFACTURING_INDUSTRY_GROUP,
  AUTO_DEALERS_INDUSTRY_GROUP,
  AUTOMOTIVE_LEASING_INDUSTRY_GROUP,
  AUTOMOTIVE_PARTS_INDUSTRY_GROUP,
  AUTOMOTIVE_REPAIR_INDUSTRY_GROUP,
  BAKERIES_MANUFACTURING_INDUSTRY_GROUP,
  BASIC_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP,
  BEER_WINE_LIQUOR_RETAILERS_INDUSTRY_GROUP,
  BEER_WINE_WHOLESALERS_INDUSTRY_GROUP,
  BEVERAGE_MANUFACTURING_INDUSTRY_GROUP,
  BOILERS_TANK_MANUFACTURING_INDUSTRY_GROUP,
  BOOK_RETAILERS_INDUSTRY_GROUP,
  BUILDING_EQUIPMENT_CONTRACTOR_INDUSTRY_GROUP,
  BUILDING_FINISHING_CONTRACTOR_INDUSTRY_GROUP,
  BUILDING_MATERIAL_AND_SUPPLIES_DEALERS_INDUSTRY_GROUP,
  BUSINESS_LABOR_POLITICAL_INDUSTRY_GROUP,
  BUSINESS_SCHOOLS_INDUSTRY_GROUP,
  BUSINESS_SUPPORT_SERVICES_INDUSTRY_GROUP,
  CATTLE_RANCHING_FARMING_INDUSTRY_GROUP,
  CEMENT_AND_CONCRETE_MANUFACTURING_INDUSTRY_GROUP,
  CHARTER_BUS_INDUSTRY_GROUP,
  CHEMICAL_AND_ALLIED_PRODUCTS_WHOLESALERS_INDUSTRY_GROUP,
  CHILD_CARE_SERVICES_INDUSTRY_GROUP,
  CLAY_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
  CLOTHING_RETAILERS_INDUSTRY_GROUP,
  COAL_MINING_INDUSTRY_GROUP,
  COATING_ENGRAVING_HEAT_TREATING_INDUSTRY_GROUP,
  COMMERCIAL_AND_SERVICE_INDUSTRY_MANUFACTURING_INDUSTRY_GROUP,
  COMMERCIAL_MACHINERY_INDUSTRY_GROUP,
  COMMERCIAL_REPAIR_AND_MAINTENANCE_INDUSTRY_GROUP,
  COMMODITY_CONTRACTS_INDUSTRY_GROUP,
  COMMODITY_EXCHANGES_INDUSTRY_GROUP,
  COMMUNICATION_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  COMPUTER_MANUFACTURING_INDUSTRY_GROUP,
  COMPUTER_SYSTEMS_DESIGN_SERVICES_INDUSTRY_GROUP,
  CONSUMER_GOODS_RENTAL_INDUSTRY_GROUP,
  CONVERTED_PAPER_MANUFACTURING_INDUSTRY_GROUP,
  COURIER_DELIVERY_INDUSTRY_GROUP,
  CRUDE_OIL_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
  CUT_AND_SEW_APPAREL_INDUSTRY_GROUP,
  CUTLERY_AND_HANDTOOL_MANUFACTURING_INDUSTRY_GROUP,
  DAIRY_MANUFACTURING_INDUSTRY_GROUP,
  DEATH_CARE_SERVICES_INDUSTRY_GROUP,
  DEEP_SEA_TRANSPORTATION_INDUSTRY_GROUP,
  DENTISTS_INDUSTRY_GROUP,
  DEPARTMENT_STORE_INDUSTRY_GROUP,
  DEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP,
  DESIGN_SERVICES_INDUSTRY_GROUP,
  DRINKING_PLACES_INDUSTRY_GROUP,
  DRUGS_WHOLESALERS_INDUSTRY_GROUP,
  EDUCATIONAL_SUPPORT_SERVICES_INDUSTRY_GROUP,
  ELECTRIC_LIGHTING_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  ELECTRIC_POWER_GENERATION_INDUSTRY_GROUP,
  ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  ELECTRONICS_REPAIR_INDUSTRY_GROUP,
  ELECTRONICS_RETAILERS_INDUSTRY_GROUP,
  ELEMENTARY_SCHOOLS_INDUSTRY_GROUP,
  EMPLOYMENTS_SERVICES_INDUSTRY_GROUP,
  ENGINE_TURBINE_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  FABRIC_MILLS_INDUSTRY_GROUP,
  FARM_PRODUCT_WHOLESALERS_INDUSTRY_GROUP,
  FIBER_YARN_MILLS_INDUSTRY_GROUP,
  FISHING_INDUSTRY_GROUP,
  FLORISTS_INDUSTRY_GROUP,
  FOOTWEAR_MANUFACTURING_INDUSTRY_GROUP,
  FOREST_NURSERIES_INDUSTRY_GROUP,
  FORGING_AND_STAMPING_INDUSTRY_GROUP,
  FOUNDATION_CONTRACTOR_INDUSTRY_GROUP,
  FOUNDRIES_INDUSTRY_GROUP,
  FREIGHT_TRANSPORTATION_AGREEMENT_INDUSTRY_GROUP,
  FRUIT_AND_TREE_NUT_INDUSTRY_GROUP,
  FRUIT_PRESERVING_MANUFACTURING_INDUSTRY_GROUP,
  FUEL_DEALERS_INDUSTRY_GROUP,
  FURNITURE_AND_HONE_WHOLESALERS_INDUSTRY_GROUP,
  FURNITURE_RETAILERS_INDUSTRY_GROUP,
  GAMBLING_INDUSTRIES_INDUSTRY_GROUP,
  GASOLINE_STATIONS_INDUSTRY_GROUP,
  GENERAL_FREIGHT_TRUCKING_INDUSTRY_GROUP,
  GENERAL_MEDICAL_INDUSTRY_GROUP,
  GENERAL_RENTAL_CENTERS_INDUSTRY_GROUP,
  GLASS_MANUFACTURING_INDUSTRY_GROUP,
  GRAIN_AND_OILSEED_MILLING_INDUSTRY_GROUP,
  GRANTMAKING_INDUSTRY_GROUP,
  GREENHOUSE_NURSERY_AND_FLORICULTURE_INDUSTRY_GROUP,
  GROCERY_RETAILERS_INDUSTRY_GROUP,
  GROCERY_WHOLESALERS_INDUSTRY_GROUP,
  HARDWARE_AND_PLUMBING_WHOLESALERS_INDUSTRY_GROUP,
  HARDWARE_MANUFACTURING_INDUSTRY_GROUP,
  HIGHWAY_CONSTRUCTION_INDUSTRY_GROUP,
  HOD_AND_PIG_FARMING_INDUSTRY_GROUP,
  HOME_HEALTH_CARE_SERVICES_INDUSTRY_GROUP,
  HOUSEHOLD_APPLIANCE_MANUFACTURING_INDUSTRY_GROUP,
  HOUSEHOLD_APPLIANCES_WHOLESALERS_INDUSTRY_GROUP,
  HOUSEHOLD_MANUFACTURING_INDUSTRY_GROUP,
  HUNTING_AND_TRAPPING_INDUSTRY_GROUP,
  INDEPENDENT_ARTISTS_INDUSTRY_GROUP,
  INDIVIDUAL_AND_FAMILY_SERVICES_INDUSTRY_GROUP,
  INDUSTRIAL_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
  INLAND_WATER_TRANSPORTATION_INDUSTRY_GROUP,
  INSURANCE_CARRIER_INDUSTRY_GROUP,
  INSURANCE_FUNDS_INDUSTRY_GROUP,
  INTERURBAN_TRANSPORTATION_INDUSTRY_GROUP,
  INVESTIGATION_AND_SECURITY_SERVICES_INDUSTRY_GROUP,
  IRON_AND_STEEL_MILLS_INDUSTRY_GROUP,
  JEWELRY_RETAILERS_INDUSTRY_GROUP,
  JUNIOR_COLLEGES_INDUSTRY_GROUP,
  LAND_SUBDIVISION_INDUSTRY_GROUP,
  LAUNDRY_SERVICES_INDUSTRY_GROUP,
  LAWN_AND_GARDEN_EQUIPMENT_INDUSTRY_GROUP,
  LEATHER_AND_HIDE_TANNING_INDUSTRY_GROUP,
  LEGAL_SERVICES_INDUSTRY_GROUP,
  LESSORS_OF_REAL_ESTATE_INDUSTRY_GROUP,
  LIME_AND_GYPSUM_MANUFACTURING_INDUSTRY_GROUP,
  LOCAL_DELIVERY_INDUSTRY_GROUP,
  LOGGING_INDUSTRY_GROUP,
  LUMBER_WHOLESALERS_INDUSTRY_GROUP,
  MACHINE_SHOPS_MANUFACTURING_INDUSTRY_GROUP,
  MACHINERY_WHOLESALERS_INDUSTRY_GROUP,
  MANUFACTURING_AND_REPRODUCING_MAGNETIC_AND_OPTICAL_MEDIA_INDUSTRY_GROUP,
  MEDIA_STREAMING_INDUSTRY_GROUP,
  MEDICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  MEDICAL_LABS_INDUSTRY_GROUP,
  METAL_AND_MINERAL_WHOLESALERS_INDUSTRY_GROUP,
  METAL_ORE_MINING_INDUSTRY_GROUP,
  METALWORKING_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
  MISCELLANEOUS_DURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
  MISCELLANEOUS_NONDURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
  MOTION_PICTURE_INDUSTRY_GROUP,
  MOTOR_VEHICLE_MANUFACTURING_INDUSTRY_GROUP,
  MOTOR_VEHICLE_WHOLESALERS_INDUSTRY_GROUP,
  NATURAL_GAS_DISTRIBUTION_INDUSTRY_GROUP,
  NATURAL_GAS_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
  NAVIGATIONAL_INSTRUMENTS_INDUSTRY_GROUP,
  NEWSPAPER_INDUSTRY_GROUP,
  NONDEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP,
  NONFERROUS_METAL_PRODUCTION_INDUSTRY_GROUP,
  NONMETALLIC_MINERAL_MINING_INDUSTRY_GROUP,
  NONRESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP,
  NONSCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP,
  NURSING_CARE_FACILITIES_INDUSTRY_GROUP,
  OFFICE_FURNITURE_MANUFACTURING_INDUSTRY_GROUP,
  OFFICE_SUPPLY_RETAILERS_INDUSTRY_GROUP,
  OFFICES_OF_REAL_ESTATE_INDUSTRY_GROUP,
  OILSEED_AND_GRAIN_INDUSTRY_GROUP,
  OTHER_AMBULATORY_HEALTH_CARE_INDUSTRY_GROUP,
  OTHER_AMUSEMENT_INDUSTRY_GROUP,
  OTHER_ANIMAL_PRODUCTION_INDUSTRY_GROUP,
  OTHER_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_CROP_FARMING_INDUSTRY_GROUP,
  OTHER_EATING_PLACES_INDUSTRY_GROUP,
  OTHER_ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_FABRICATED_TOOL_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_FINANCIAL_INVESTMENT_ACTIVITIES_INDUSTRY_GROUP,
  OTHER_FOOD_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_FUNDS_FUNDS_INDUSTRY_GROUP,
  OTHER_FURNITURE_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_GENERAL_PURPOSE_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_HEALTH_PRACTITIONERS_INDUSTRY_GROUP,
  OTHER_HEAVY_CONSTRUCTION_INDUSTRY_GROUP,
  OTHER_LEATHER_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_MISCELLANEOUS_INDUSTRY_GROUP,
  OTHER_MISCELLANEOUS_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_MOTOR_DEALERS_INDUSTRY_GROUP,
  OTHER_NONMETALLIC_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_PERSONAL_SERVICES_INDUSTRY_GROUP,
  OTHER_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
  OTHER_RELIEF_SERVICES_INDUSTRY_GROUP,
  OTHER_RESIDENTIAL_CARE_INDUSTRY_GROUP,
  OTHER_SCHOOLS_INDUSTRY_GROUP,
  OTHER_SPECIALTY_TRADE_CONTRACTORS_INDUSTRY_GROUP,
  OTHER_SUPPORT_SERVICES_INDUSTRY_GROUP,
  OTHER_SUPPORT_TRANSPORTATION_INDUSTRY_GROUP,
  OTHER_TECHNICAL_SERVICES_INDUSTRY_GROUP,
  OTHER_TELECOMMUNICATIONS_INDUSTRY_GROUP,
  OTHER_TEXTILE_MILLS_INDUSTRY_GROUP,
  OTHER_TRANSIT_TRANSPORTATION_INDUSTRY_GROUP,
  OTHER_TRANSPORTATION_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_WOOD_PRODUCT_INDUSTRY_GROUP,
  OUTPATIENT_CARE_CENTERS_INDUSTRY_GROUP,
  PAINT_COATING_MANUFACTURING_INDUSTRY_GROUP,
  PAPER_AND_PRODUCT_WHOLESALERS_INDUSTRY_GROUP,
  PERFORMING_ARTS_COMPANIES_INDUSTRY_GROUP,
  PERSONAL_CARE_SERVICES_INDUSTRY_GROUP,
  PERSONAL_GOODS_REPAIR_INDUSTRY_GROUP,
  PESTICIDE_FERTILIZER_MANUFACTURING_INDUSTRY_GROUP,
  PETROLEUM_WHOLESALERS_INDUSTRY_GROUP,
  PHARMACEUTICAL_AND_MEDICINE_MANUFACTURING_INDUSTRY_GROUP,
  PHYSICIANS_INDUSTRY_GROUP,
  PLASTIC_MANUFACTURING_INDUSTRY_GROUP,
  POULTRY_AND_EGG_INDUSTRY_GROUP,
  PROF_AND_COMMERCIAL_EQUIPMENT_WHOLESALERS_INDUSTRY_GROUP,
  PROFESSIONAL_SCHOOLS_INDUSTRY_GROUP,
  PROMOTERS_OF_PERFORMING_ARTS_INDUSTRY_GROUP,
  PULP_PAPER_MILLS_INDUSTRY_GROUP,
  RADIO_AND_TELEVISION_INDUSTRY_GROUP,
  RAILROAD_MANUFACTURING_INDUSTRY_GROUP,
  RECREATIONAL_CAMPS_INDUSTRY_GROUP,
  RELIGIOUS_ORGANIZATIONS_INDUSTRY_GROUP,
  REMEDIATION_AND_OTHER_WASTE_MANAGEMENT_SERVICE_INDUSTRY_GROUP,
  RESERVATION_SERVICES_INDUSTRY_GROUP,
  RESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP,
  RESIDENTIAL_INTELLECTUAL_INDUSTRY_GROUP,
  RESIN_SYNTHETIC_RUBBER_MANUFACTURING_INDUSTRY_GROUP,
  RETIREMENT_COMMUNITIES_INDUSTRY_GROUP,
  RUBBER_MANUFACTURING_INDUSTRY_GROUP,
  SATELLITE_TELECOMMUNICATIONS_INDUSTRY_GROUP,
  SAWMILLS_AND_WOOD_PRESERVATION_INDUSTRY_GROUP,
  SCENIC_LAND_INDUSTRY_GROUP,
  SCENIC_OTHER_INDUSTRY_GROUP,
  SCENIC_WATER_INDUSTRY_GROUP,
  SCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP,
  SCHOOL_TRANSPORTATION_INDUSTRY_GROUP,
  SCIENTIFIC_RESEARCH_SERVICES_INDUSTRY_GROUP,
  SEAFOOD_PREPARATION_INDUSTRY_GROUP,
  SEMICONDUCTOR_MANUFACTURING_INDUSTRY_GROUP,
  SERVICES_TO_BUILDINGS_INDUSTRY_GROUP,
  SHEEP_AND_GOAT_INDUSTRY_GROUP,
  SHIP_AND_BOAT_BUILDING_INDUSTRY_GROUP,
  SHOE_RETAILERS_INDUSTRY_GROUP,
  SOAP_CLEANING_COMPOUND_MANUFACTURING_INDUSTRY_GROUP,
  SOCIAL_ADVOCACY_INDUSTRY_GROUP,
  SOCIAL_ORGANIZATIONS_INDUSTRY_GROUP,
  SOFTWARE_PUBLISHERS_INDUSTRY_GROUP,
  SOUND_INDUSTRY_GROUP,
  SPECIAL_FOOD_SERVICES_INDUSTRY_GROUP,
  SPECIALIZED_FREIGHT_TRUCKING_INDUSTRY_GROUP,
  SPECIALTY_FOOD_RETAILERS_INDUSTRY_GROUP,
  SPECIALTY_HOSPITALS__INDUSTRY_GROUP,
  SPECTATOR_SPORTS_INDUSTRY_GROUP,
  SPORTING_GOODS_RETAILERS_INDUSTRY_GROUP,
  SPRING_AND_WIRE_MANUFACTURING_INDUSTRY_GROUP,
  STEEL_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
  SUBSTANCE_ABUSE_HOSPITALS_INDUSTRY_GROUP,
  SUGAR_MANUFACTURING_INDUSTRY_GROUP,
  SUPPORT_ACTIVITIES_FOR_CROP_INDUSTRY_GROUP,
  SUPPORT_FOR_AIR_TRANSPORTATION_INDUSTRY_GROUP,
  SUPPORT_FOR_RAIL_TRANSPORTATION_INDUSTRY_GROUP,
  SUPPORT_FOR_ROAD_TRANSPORTATION_INDUSTRY_GROUP,
  SUPPORT_FOR_WATER_TRANSPORTATION_INDUSTRY_GROUP,
  TAXI_SERVICE_INDUSTRY_GROUP,
  TECHNICAL_CONSULTING_SERVICES_INDUSTRY_GROUP,
  TEXTILE_FURNISHING_MILLS_INDUSTRY_GROUP,
  TEXTILE_MILLS_INDUSTRY_GROUP,
  TIMBER_TRACK_OPERATIONS_INDUSTRY_GROUP,
  TOBACCO_MANUFACTURING_INDUSTRY_GROUP,
  TRADE_SCHOOLS_INDUSTRY_GROUP,
  TRAVELER_ACCOMMODATION_INDUSTRY_GROUP,
  URBAN_TRANSIT_SYSTEMS_INDUSTRY_GROUP,
  USED_MERCHANDISE_INDUSTRY_GROUP,
  UTILITY_SYSTEM_CONSTRUCTION_INDUSTRY_GROUP,
  VEGETABLE_AND_MELON_INDUSTRY_GROUP,
  VEHICLE_BODY_MANUFACTURING_INDUSTRY_GROUP,
  VEHICLE_PARTS_MANUFACTURING_INDUSTRY_GROUP,
  VENEER_PLYWOOD_INDUSTRY_GROUP,
  VENTILATION_HEATING_AIR_CONDITIONING_MANUFACTURING_INDUSTRY_GROUP,
  VOCATIONAL_REHABILITATION_SERVICES_INDUSTRY_GROUP,
  WAREHOUSE_CLUBS_RETAILERS_INDUSTRY_GROUP,
  WASTE_COLLECTION_INDUSTRY_GROUP,
  WASTE_DISPOSAL_INDUSTRY_GROUP,
  WIRED_TELECOMMUNICATIONS_INDUSTRY_GROUP,
  WORKERS_CAMPS_INDUSTRY_GROUP,
} from '../industryGroupOptions';
import { MANAGEMENT_OF_COMPANIES_SECTOR } from '../industrySectorOptions';
import {
  ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR,
  ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR,
  AGENTS_AND_BROKERS_SUB_SECTOR,
  COMPUTING_INFRASTRUCTURE_SUB_SECTOR,
  EXECUTIVE_LEGISLATIVE_SUB_SECTOR,
  HEALTH_RETAILERS_SUB_SECTOR,
  JUSTICE_PUBLIC_ORDER_SUB_SECTOR,
  LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR,
  MINING_SUPPORT_ACTIVITIES_SUB_SECTOR,
  MONETARY_BANK_SUB_SECTOR,
  MUSEUMS_SUB_SECTOR,
  NATIONAL_SECURITY_SUB_SECTOR,
  OIL_GAS_EXTRACTION_SUB_SECTOR,
  PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR,
  POSTAL_SERVICE_SUB_SECTOR,
  PRINTING_MANUFACTURING_SUB_SECTOR,
  PRIVATE_HOUSEHOLDS_SUB_SECTOR,
  RAIL_TRANSPORTATION_SUB_SECTOR,
  SPACE_RESEARCH_SUB_SECTOR,
  WAREHOUSING_AND_STORAGE_SUB_SECTOR,
  WEB_SEARCH_PORTALS_SUB_SECTOR,
} from '../industrySubSectorOptions';

export const INDUSTRY_OPTIONS_DEU = {
  [OILSEED_AND_GRAIN_INDUSTRY_GROUP]: [
    { value: '11111', label: 'Sojabohnenanbau' },
    { value: '11112', label: 'Anbau von Ölsaaten (ohne Sojabohnen)' },
    { value: '11113', label: 'Anbau von Trockenerbsen und Bohnen' },
    { value: '11114', label: 'Weizenanbau' },
    { value: '11115', label: 'Maisanbau' },
    { value: '11116', label: 'Reisanbau' },
    { value: '111191', label: 'Kombinierter Anbau von Ölsaaten und Getreide' },
    { value: '111199', label: 'Sonstiger Getreideanbau' },
  ],
  [VEGETABLE_AND_MELON_INDUSTRY_GROUP]: [
    { value: '111211', label: 'Kartoffelanbau' },
    { value: '111219', label: 'Anbau sonstiger Gemüse (ohne Kartoffeln) und Melonen' },
  ],
  [FRUIT_AND_TREE_NUT_INDUSTRY_GROUP]: [
    { value: '11131', label: 'Orangenplantagen' },
    { value: '11132', label: 'Zitrusplantagen (ohne Orangen)' },
    { value: '111331', label: 'Apfelplantagen' },
    { value: '111332', label: 'Weinberge (Traubenanbau)' },
    { value: '111333', label: 'Erdbeeranbau' },
    { value: '111334', label: 'Anbau sonstiger Beeren (ohne Erdbeeren)' },
    { value: '111335', label: 'Anbau von Schalen- und Baumnüssen' },
    { value: '111336', label: 'Kombinierter Anbau von Obst und Baumnüssen' },
    { value: '111339', label: 'Anbau sonstiger nicht-zitrischer Früchte' },
  ],
  [GREENHOUSE_NURSERY_AND_FLORICULTURE_INDUSTRY_GROUP]: [
    { value: '111411', label: 'Pilzzucht' },
    { value: '111419', label: 'Anbau sonstiger Nahrungspflanzen unter Glas/Abdeckung' },
    { value: '111421', label: 'Baumschulen- und Jungpflanzenproduktion' },
    { value: '111422', label: 'Zierpflanzen- und Blumenproduktion' },
  ],
  [OTHER_CROP_FARMING_INDUSTRY_GROUP]: [
    { value: '11191', label: 'Tabakanbau' },
    { value: '11192', label: 'Baumwollanbau' },
    { value: '11193', label: 'Zuckerrohranbau' },
    { value: '11194', label: 'Heuanbau' },
    { value: '111991', label: 'Zuckerrübenanbau' },
    { value: '111992', label: 'Erdnussanbau' },
    { value: '111998', label: 'Sonstiger verschiedenartiger Pflanzenanbau' },
  ],
  [CATTLE_RANCHING_FARMING_INDUSTRY_GROUP]: [
    { value: '112111', label: 'Rinderzucht und -haltung (Fleischrinder)' },
    { value: '112112', label: 'Rinder-Mastbetriebe' },
    { value: '11212', label: 'Milchviehhaltung und Milchproduktion' },
    { value: '11213', label: 'Rinderzucht und -haltung für Doppelzwecke (Milch und Fleisch)' },
  ],
  [HOD_AND_PIG_FARMING_INDUSTRY_GROUP]: [],
  [POULTRY_AND_EGG_INDUSTRY_GROUP]: [
    { value: '11231', label: 'Hühnereierproduktion' },
    { value: '11232', label: 'Mastgeflügel- und sonstige Hähnchenfleischproduktion' },
    { value: '11233', label: 'Putenhaltung und -produktion' },
    { value: '11233', label: 'Geflügelbrütereien' },
    { value: '11239', label: 'Sonstige Geflügelproduktion' },
  ],
  [SHEEP_AND_GOAT_INDUSTRY_GROUP]: [
    { value: '11241', label: 'Schafhaltung' },
    { value: '11242', label: 'Ziegenhaltung' },
  ],
  [AQUACULTURE_INDUSTRY_GROUP]: [
    { value: '112511', label: 'Zucht von Speisefischen und Fischbrütereien' },
    { value: '112512', label: 'Schalentierzucht' },
    { value: '112519', label: 'Sonstige Aquakultur' },
  ],
  [OTHER_ANIMAL_PRODUCTION_INDUSTRY_GROUP]: [
    { value: '11291', label: 'Imkerei' },
    { value: '11292', label: 'Zucht von Pferden und sonstigen Equiden' },
    { value: '11293', label: 'Zucht von Pelztieren und Kaninchen' },
    { value: '11299', label: 'Sonstige Tierproduktion' },
  ],
  [TIMBER_TRACK_OPERATIONS_INDUSTRY_GROUP]: [],
  [FOREST_NURSERIES_INDUSTRY_GROUP]: [],
  [LOGGING_INDUSTRY_GROUP]: [],
  [FISHING_INDUSTRY_GROUP]: [
    { value: '114111', label: 'Fischfang (Knochenfische)' },
    { value: '114112', label: 'Fang von Schalentieren' },
    { value: '114119', label: 'Sonstiger Meeresfischfang' },
  ],
  [HUNTING_AND_TRAPPING_INDUSTRY_GROUP]: [],
  [SUPPORT_ACTIVITIES_FOR_CROP_INDUSTRY_GROUP]: [
    { value: '115111', label: 'Entkörnung von Baumwolle (Cotton Ginning)' },
    { value: '115112', label: 'Bodenbearbeitung, Aussaat und Anbauarbeiten' },
    { value: '115113', label: 'Mechanisierte Erntearbeiten' },
    { value: '115114', label: 'Nachernte-Tätigkeiten (ohne Baumwollentkörnung)' },
    { value: '115115', label: 'Landwirtschaftliche Arbeitskräftevermittlung und Kolonnenführer' },
    { value: '115116', label: 'Betriebsführung landwirtschaftlicher Betriebe' },
  ],
  [OIL_GAS_EXTRACTION_SUB_SECTOR]: [
    { value: '21112', label: 'Förderung von Rohöl' },
    { value: '21113', label: 'Förderung von Erdgas' },
  ],
  [COAL_MINING_INDUSTRY_GROUP]: [
    { value: '212114', label: 'Tagebau von Steinkohle/Braunkohle' },
    { value: '212115', label: 'Untertagebau von Steinkohle/Braunkohle' },
  ],
  [METAL_ORE_MINING_INDUSTRY_GROUP]: [
    { value: '21221', label: 'Eisenerzbergbau' },
    { value: '21222', label: 'Gold- und Silbererzbergbau' },
    { value: '21223', label: 'Kupfer-, Nickel-, Blei- und Zinkerzbergbau' },
    { value: '21229', label: 'Sonstiger Metallerzbergbau' },
  ],
  [NONMETALLIC_MINERAL_MINING_INDUSTRY_GROUP]: [
    { value: '212311', label: 'Gewinnung von Naturwerksteinen' },
    { value: '212312', label: 'Gewinnung und Aufbereitung von Kalkstein (Bruch- und Splittkalk)' },
    { value: '212313', label: 'Gewinnung und Aufbereitung von Granit (Bruch- und Splittgranit)' },
    { value: '212319', label: 'Gewinnung sonstiger gebrochener und zerkleinerter Steine' },
    { value: '212321', label: 'Gewinnung von Bau- und Kieston/Sand (Bausand und -kies)' },
    { value: '212322', label: 'Gewinnung von Industriesand' },
    { value: '212323', label: 'Gewinnung von Kaolin, Ton und feuerfesten Mineralien' },
    { value: '21239', label: 'Sonstiger Abbau nichtmetallischer Mineralien und Steinbrüche' },
  ],
  [MINING_SUPPORT_ACTIVITIES_SUB_SECTOR]: [
    { value: '213111', label: 'Bohren von Öl- und Gasbohrungen' },
    { value: '213112', label: 'Unterstützende Tätigkeiten für Öl- und Gasförderung' },
    { value: '213113', label: 'Unterstützende Tätigkeiten für den Kohlebergbau' },
    { value: '213114', label: 'Unterstützende Tätigkeiten für den Metallerzbergbau' },
    {
      value: '213115',
      label: 'Unterstützende Tätigkeiten für den Abbau nichtmetallischer Mineralien (ohne Brennstoffe)',
    },
  ],
  [ELECTRIC_POWER_GENERATION_INDUSTRY_GROUP]: [
    { value: '221111', label: 'Stromerzeugung aus Wasserkraft' },
    { value: '221112', label: 'Stromerzeugung aus fossilen Brennstoffen' },
    { value: '221113', label: 'Kernkraft-Stromerzeugung' },
    { value: '221114', label: 'Stromerzeugung aus Solarenergie' },
    { value: '221115', label: 'Stromerzeugung aus Windenergie' },
    { value: '221116', label: 'Stromerzeugung aus Geothermie' },
    { value: '221117', label: 'Stromerzeugung aus Biomasse' },
    { value: '221118', label: 'Sonstige Stromerzeugung' },
    { value: '221121', label: 'Übertragung von Strom im Hochspannungsnetz und Netzsteuerung' },
    { value: '221122', label: 'Elektrizitätsverteilung' },
  ],
  [NATURAL_GAS_DISTRIBUTION_INDUSTRY_GROUP]: [
    { value: '22131', label: 'Wasserversorgung und Bewässerungssysteme' },
    { value: '22132', label: 'Abwasseraufbereitungseinrichtungen' },
    { value: '22133', label: 'Dampf- und Kälte-/Klimaversorgung' },
  ],
  [RESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP]: [
    {
      value: '236115',
      label: 'Neubau von Einfamilienhäusern (außer Bauträger für den Verkauf)',
    },
    {
      value: '236116',
      label: 'Neubau von Mehrfamilienhäusern (außer Bauträger für den Verkauf)',
    },
    { value: '236117', label: 'Neubau von Wohngebäuden durch Bauträger (zum Verkauf)' },
    { value: '236118', label: 'Wohngebäudesanierung und -umbau' },
  ],
  [NONRESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP]: [
    { value: '23621', label: 'Industriebau' },
    { value: '23622', label: 'Bau von gewerblichen und institutionellen Gebäuden' },
  ],
  [UTILITY_SYSTEM_CONSTRUCTION_INDUSTRY_GROUP]: [
    {
      value: '23711',
      label: 'Bau von Wasser- und Abwasserleitungen und zugehörigen Anlagen',
    },
    {
      value: '23712',
      label: 'Bau von Öl- und Gaspipelines und zugehörigen Anlagen',
    },
    {
      value: '23713',
      label: 'Bau von Strom- und Kommunikationsleitungen und zugehörigen Anlagen',
    },
  ],
  [LAND_SUBDIVISION_INDUSTRY_GROUP]: [],
  [HIGHWAY_CONSTRUCTION_INDUSTRY_GROUP]: [],
  [OTHER_HEAVY_CONSTRUCTION_INDUSTRY_GROUP]: [],
  [FOUNDATION_CONTRACTOR_INDUSTRY_GROUP]: [
    { value: '23811', label: 'Unternehmen für Betonfundamente und Tragwerke' },
    { value: '23812', label: 'Unternehmen für Stahlkonstruktionen und Fertigbetonteile' },
    { value: '23813', label: 'Holzrahmen- und Rohbauunternehmen' },
    { value: '23814', label: 'Maurerbetriebe' },
    { value: '23815', label: 'Glaserei- und Verglasungsbetriebe' },
    { value: '23816', label: 'Dachdeckerbetriebe' },
    { value: '23817', label: 'Fassaden- und Verkleidungsunternehmen' },
    {
      value: '23819',
      label: 'Sonstige Unternehmen für Fundamente, Tragwerke und Außenhüllen von Gebäuden',
    },
  ],
  [BUILDING_EQUIPMENT_CONTRACTOR_INDUSTRY_GROUP]: [
    {
      value: '23821',
      label: 'Elektroinstallationsunternehmen und sonstige Verkabelungsinstallateure',
    },
    {
      value: '23822',
      label: 'Installationsbetriebe für Sanitär-, Heizungs- und Klimaanlagen',
    },
    { value: '23829', label: 'Sonstige Unternehmen für technische Gebäudeausrüstung' },
  ],
  [BUILDING_FINISHING_CONTRACTOR_INDUSTRY_GROUP]: [
    { value: '23831', label: 'Trockenbau- und Dämmungsbetriebe' },
    { value: '23832', label: 'Maler- und Tapezierbetriebe' },
    { value: '23833', label: 'Bodenlegerbetriebe' },
    { value: '23834', label: 'Fliesen- und Terrazzounternehmen' },
    { value: '23835', label: 'Innenausbau- und Tischlerbetriebe (Endausbau)' },
    { value: '23839', label: 'Sonstige Unternehmen für den Innenausbau von Gebäuden' },
  ],
  [OTHER_SPECIALTY_TRADE_CONTRACTORS_INDUSTRY_GROUP]: [
    { value: '23891', label: 'Erd- und Baustellenvorbereitungsunternehmen' },
    { value: '23899', label: 'Sonstige spezialisierte Bau- und Ausbaubetriebe' },
  ],
  [ANIMAL_FOOD_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '311111', label: 'Herstellung von Hunden- und Katzenfutter' },
    { value: '311119', label: 'Herstellung sonstiger Tiernahrung' },
  ],
  [GRAIN_AND_OILSEED_MILLING_INDUSTRY_GROUP]: [
    { value: '311211', label: 'Mühlenbetrieb für Getreide (Mehlmüllerei)' },
    { value: '311212', label: 'Reismühlen' },
    { value: '311213', label: 'Herstellung von Malz' },
    {
      value: '311221',
      label: 'Nassmahlung von Mais und Herstellung von Stärke',
    },
    {
      value: '311224',
      label: 'Verarbeitung von Sojabohnen und anderen Ölsaaten',
    },
    {
      value: '311224',
      label: 'Raffination und Mischung von Fetten und Ölen',
    },
    { value: '31123', label: 'Herstellung von Frühstücksgetreide' },
  ],
  [SUGAR_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '311313', label: 'Herstellung von Rübenzucker' },
    { value: '311314', label: 'Herstellung von Rohrzucker' },
    { value: '31134', label: 'Herstellung von Zuckerwaren (ohne Schokolade)' },
    { value: '31135', label: 'Herstellung von Schokolade und Schokoladenerzeugnissen' },
  ],
  [FRUIT_PRESERVING_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '311411',
      label: 'Herstellung von Tiefkühlobst, -säften und -gemüse',
    },
    { value: '311412', label: 'Herstellung von Tiefkühl-Fertig- und Speziallebensmitteln' },
    { value: '311421', label: 'Obst- und Gemüsekonservenherstellung' },
    { value: '311422', label: 'Herstellung von Spezialkonserven' },
    { value: '311423', label: 'Herstellung von getrockneten und dehydrierten Lebensmitteln' },
  ],
  [DAIRY_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '311511', label: 'Herstellung von Trinkmilch' },
    { value: '311512', label: 'Herstellung von Butter' },
    { value: '311513', label: 'Käseherstellung' },
    {
      value: '311514',
      label: 'Herstellung von Trockenmilch, Kondensmilch und anderen Milchpulvererzeugnissen',
    },
    { value: '31152', label: 'Herstellung von Speiseeis und Tiefkühl-Desserts' },
  ],
  [ANIMAL_SLAUGHTERING_INDUSTRY_GROUP]: [
    { value: '311611', label: 'Schlachtung von Tieren (ohne Geflügel)' },
    { value: '311612', label: 'Verarbeitung von Fleisch aus Schlachtkörpern' },
    { value: '311613', label: 'Herstellung von Schlachtnebenerzeugnissen und Tierfetten' },
    { value: '311615', label: 'Geflügelschlachtung und -verarbeitung' },
  ],
  [SEAFOOD_PREPARATION_INDUSTRY_GROUP]: [],
  [BAKERIES_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '311811', label: 'Bäckereien (Einzelhandel)' },
    { value: '311812', label: 'Industrielle Bäckereien' },
    {
      value: '311813',
      label: 'Herstellung von tiefgekühlten Kuchen, Torten und sonstigem Feingebäck',
    },
    { value: '311821', label: 'Herstellung von Keksen und Crackern' },
    {
      value: '311824',
      label: 'Herstellung von Trockenpasta, Teigwaren und Backmischungen aus gekauftem Mehl',
    },
    { value: '31183', label: 'Herstellung von Tortillas' },
  ],
  [OTHER_FOOD_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '311911',
      label: 'Herstellung von gerösteten Nüssen und Erdnussbutter',
    },
    { value: '311919', label: 'Herstellung sonstiger Snackprodukte' },
    { value: '31192', label: 'Herstellung von Kaffee und Tee' },
    { value: '31193', label: 'Herstellung von Sirupen und Aromakonzentraten' },
    {
      value: '311941',
      label: 'Herstellung von Mayonnaise, Dressings und sonstigen Fertigsaucen',
    },
    { value: '311942', label: 'Herstellung von Gewürzen und Extrakten' },
    { value: '31199', label: 'Sonstige Nahrungsmittelherstellung' },
  ],
  [BEVERAGE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '312111', label: 'Herstellung von Erfrischungsgetränken' },
    { value: '312112', label: 'Herstellung von abgefülltem Wasser' },
    { value: '312113', label: 'Herstellung von Eis' },
    { value: '31212', label: 'Brauereien' },
    { value: '31213', label: 'Weinkellereien' },
    { value: '31214', label: 'Brennereien (Spirituosenherstellung)' },
  ],
  [TOBACCO_MANUFACTURING_INDUSTRY_GROUP]: [],
  [FIBER_YARN_MILLS_INDUSTRY_GROUP]: [],
  [FABRIC_MILLS_INDUSTRY_GROUP]: [
    { value: '31321', label: 'Herstellung von Breitgeweben' },
    {
      value: '31322',
      label: 'Herstellung von Schmalgeweben und Schiffli-Maschinenstickerei',
    },
    { value: '31323', label: 'Herstellung von Vliesstoffen' },
    { value: '31324', label: 'Herstellung von Maschenwaren (Strick- und Wirkwaren)' },
  ],
  [TEXTILE_MILLS_INDUSTRY_GROUP]: [
    { value: '31331', label: 'Veredelung von Textilien und Geweben' },
    { value: '31332', label: 'Herstellung von beschichteten Geweben' },
  ],
  [TEXTILE_FURNISHING_MILLS_INDUSTRY_GROUP]: [
    { value: '31411', label: 'Herstellung von Teppichen und Auslegwaren' },
    { value: '31412', label: 'Herstellung von Vorhängen, Gardinen und Hauswäsche' },
  ],
  [OTHER_TEXTILE_MILLS_INDUSTRY_GROUP]: [
    { value: '31491', label: 'Herstellung von Textilsäcken und Planen' },
    {
      value: '314994',
      label: 'Herstellung von Seilen, Schnüren, Zwirnen sowie Reifen- und Karkassengeweben',
    },
    {
      value: '314999',
      label: 'Sonstige Herstellung von diversen Textilwaren',
    },
  ],
  [APPAREL_KNITTING_MILLS_INDUSTRY_GROUP]: [],
  [CUT_AND_SEW_APPAREL_INDUSTRY_GROUP]: [
    { value: '31521', label: 'Lohnbetriebe für Zuschnitt und Konfektion von Bekleidung' },
    {
      value: '31525',
      label: 'Herstellung von Bekleidung (ohne reine Lohnkonfektion)',
    },
  ],
  [APPAREL_ACCESSORIES_INDUSTRY_GROUP]: [],
  [LEATHER_AND_HIDE_TANNING_INDUSTRY_GROUP]: [],
  [FOOTWEAR_MANUFACTURING_INDUSTRY_GROUP]: [],
  [OTHER_LEATHER_MANUFACTURING_INDUSTRY_GROUP]: [],
  [SAWMILLS_AND_WOOD_PRESERVATION_INDUSTRY_GROUP]: [
    { value: '321113', label: 'Sägewerke' },
    { value: '321114', label: 'Holzschutz und Imprägnierung' },
  ],
  [VENEER_PLYWOOD_INDUSTRY_GROUP]: [
    {
      value: '321211',
      label: 'Herstellung von Furnieren und Sperrholz aus Hartholz',
    },
    {
      value: '321212',
      label: 'Herstellung von Furnieren und Sperrholz aus Weichholz',
    },
    {
      value: '321215',
      label: 'Herstellung von tragenden Holzbauteilen (Engineered Wood)',
    },
    {
      value: '321219',
      label: 'Herstellung rekonstruierter Holzwerkstoffe',
    },
  ],
  [OTHER_WOOD_PRODUCT_INDUSTRY_GROUP]: [
    { value: '321911', label: 'Herstellung von Holzfenstern und -türen' },
    {
      value: '321912',
      label: 'Zuschnitt, Besäumen und Hobeln von Holz',
    },
    {
      value: '321918',
      label: 'Sonstige Holzverarbeitung (einschließlich Bodenbeläge)',
    },
    { value: '32192', label: 'Herstellung von Holzbehältern und Paletten' },
    {
      value: '321991',
      label: 'Herstellung von Fertig- und Mobilheimen (Wohnmobile aus Holz)',
    },
    {
      value: '321992',
      label: 'Herstellung vorgefertigter Holzgebäude',
    },
    {
      value: '321999',
      label: 'Sonstige Herstellung von Holzprodukten',
    },
  ],
  [PULP_PAPER_MILLS_INDUSTRY_GROUP]: [
    { value: '32211', label: 'Zellstofffabriken' },
    { value: '32212', label: 'Papierfabriken' },
    { value: '32213', label: 'Karton- und Pappenfabriken' },
  ],
  [CONVERTED_PAPER_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32221', label: 'Herstellung von Verpackungen aus Karton/Pappe' },
    {
      value: '32222',
      label: 'Herstellung von Papierbeuteln sowie beschichtetem und behandeltem Papier',
    },
    { value: '32223', label: 'Herstellung von Papierwaren (Schreibwaren, Büroartikel)' },
    { value: '322291', label: 'Herstellung von Hygienepapierprodukten' },
    {
      value: '322299',
      label: 'Sonstige Herstellung von veredelten Papierprodukten',
    },
  ],
  [BASIC_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32511', label: 'Herstellung von petrochemischen Erzeugnissen' },
    { value: '32512', label: 'Herstellung von Industriegasen' },
    { value: '32513', label: 'Herstellung synthetischer Farbstoffe und Pigmente' },
    {
      value: '32518',
      label: 'Herstellung sonstiger anorganischer Grundchemikalien',
    },
    { value: '325193', label: 'Herstellung von Ethylalkohol' },
    {
      value: '325194',
      label: 'Herstellung von zyklischen Rohstoffen, Zwischenprodukten sowie Harz- und Holzhilfschemikalien',
    },
    {
      value: '325199',
      label: 'Sonstige Herstellung organischer Grundchemikalien',
    },
  ],
  [RESIN_SYNTHETIC_RUBBER_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '325211',
      label: 'Herstellung von Kunststoffen und Harzen in Primärform',
    },
    { value: '325212', label: 'Herstellung von Synthesekautschuk' },
    {
      value: '32522',
      label: 'Herstellung künstlicher und synthetischer Fasern und Filamente',
    },
  ],
  [PESTICIDE_FERTILIZER_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '325311', label: 'Herstellung von stickstoffhaltigen Düngemitteln' },
    { value: '325312', label: 'Herstellung von phosphathaltigen Düngemitteln' },
    { value: '325314', label: 'Herstellung von Mischdüngern' },
    { value: '325315', label: 'Herstellung von Kompost' },
    {
      value: '32532',
      label: 'Herstellung von Pflanzenschutzmitteln und sonstigen Agrochemikalien',
    },
  ],
  [PHARMACEUTICAL_AND_MEDICINE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '325411', label: 'Herstellung medizinischer und botanischer Wirkstoffe' },
    { value: '325412', label: 'Herstellung pharmazeutischer Präparate' },
    { value: '325413', label: 'Herstellung von In-vitro-Diagnostika' },
    {
      value: '325414',
      label: 'Herstellung biologischer Produkte (ohne diagnostische Produkte)',
    },
  ],
  [PAINT_COATING_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32551', label: 'Herstellung von Farben und Lacken' },
    { value: '32552', label: 'Herstellung von Klebstoffen' },
  ],

  [SOAP_CLEANING_COMPOUND_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '325611', label: 'Herstellung von Seifen und sonstigen Waschmitteln' },
    { value: '325612', label: 'Herstellung von Polituren und sonstigen Reinigungs- und Hygienemitteln' },
    { value: '325613', label: 'Herstellung von Tensiden (oberflächenaktiven Stoffen)' },
    { value: '32562', label: 'Herstellung von Toiletten- und Körperpflegeartikeln' },
  ],
  [OTHER_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32591', label: 'Herstellung von Druckfarben' },
    { value: '32592', label: 'Herstellung von Sprengstoffen' },
    { value: '325991', label: 'Auftragsmischung von zugekauften Harzen' },
    {
      value: '325992',
      label: 'Herstellung von fotografischen Filmen, Papieren, Platten, Chemikalien und Kopiertoner',
    },
    {
      value: '325998',
      label: 'Sonstige Herstellung von chemischen Erzeugnissen und Zubereitungen',
    },
  ],
  [PLASTIC_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '326111', label: 'Herstellung von Kunststoffbeuteln und -säcken' },
    {
      value: '326112',
      label: 'Herstellung von Kunststoffverpackungsfolien und -platten (einschließlich laminiert)',
    },
    {
      value: '326113',
      label: 'Herstellung von unlaminierten Kunststofffolien und -platten (ohne Verpackungszwecke)',
    },
    { value: '326121', label: 'Herstellung von unlaminierten Kunststoffprofilen' },
    { value: '326122', label: 'Herstellung von Kunststoffrohren und -fittings' },
    {
      value: '32613',
      label: 'Herstellung von laminierten Kunststoffplatten und -formen (ohne Verpackungszwecke)',
    },
    { value: '32614', label: 'Herstellung von Polystyrolschaum-Erzeugnissen' },
    {
      value: '32615',
      label: 'Herstellung von Polyurethan- und sonstigen Schaumerzeugnissen (ohne Polystyrol)',
    },
    { value: '32616', label: 'Herstellung von Kunststoffflaschen' },
    { value: '326191', label: 'Herstellung von Sanitär- und Badeeinrichtungen aus Kunststoff' },
    { value: '326199', label: 'Sonstige Herstellung von Kunststoffwaren' },
  ],
  [RUBBER_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '326211', label: 'Reifenherstellung (ohne Runderneuerung)' },
    { value: '326212', label: 'Runderneuerung von Reifen' },
    {
      value: '32622',
      label: 'Herstellung von Schläuchen, Schläuchen mit Einlagen und Förderbändern aus Gummi und Kunststoff',
    },
    {
      value: '326291',
      label: 'Herstellung von Gummiwaren für technische und mechanische Verwendung',
    },
    { value: '326299', label: 'Sonstige Herstellung von Gummiwaren' },
  ],
  [CLAY_PRODUCT_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '32711',
      label: 'Herstellung von Keramik, Töpferwaren und Sanitärkeramik',
    },
    {
      value: '32712',
      label: 'Herstellung von keramischen Baustoffen und feuerfesten Erzeugnissen',
    },
  ],
  [GLASS_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '327211', label: 'Herstellung von Flachglas' },
    {
      value: '327212',
      label: 'Herstellung sonstiger gepresster und geblasener Glaswaren',
    },
    { value: '327213', label: 'Herstellung von Glasverpackungen' },
    {
      value: '327215',
      label: 'Herstellung von Glaswaren aus zugekauftem Glas',
    },
  ],
  [CEMENT_AND_CONCRETE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32731', label: 'Zementherstellung' },
    { value: '32732', label: 'Herstellung von Transportbeton' },
    {
      value: '327331',
      label: 'Herstellung von Betonsteinen und -ziegeln',
    },
    { value: '327332', label: 'Herstellung von Betonrohren' },
    { value: '32739', label: 'Sonstige Herstellung von Betonerzeugnissen' },
  ],
  [LIME_AND_GYPSUM_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32741', label: 'Kalkherstellung' },
    { value: '32742', label: 'Herstellung von Gipsprodukten' },
  ],
  [OTHER_NONMETALLIC_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32791', label: 'Herstellung von Schleifmitteln' },
    {
      value: '327991',
      label: 'Herstellung von geschnittenen Natursteinen und Steinprodukten',
    },
    {
      value: '327992',
      label: 'Herstellung von gemahlenen oder aufbereiteten Mineralien und Erden',
    },
    { value: '327993', label: 'Herstellung von Mineralwolle' },
    {
      value: '327999',
      label: 'Sonstige Herstellung von nichtmetallischen Mineralprodukten',
    },
  ],
  [IRON_AND_STEEL_MILLS_INDUSTRY_GROUP]: [],
  [STEEL_PRODUCT_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '33121',
      label: 'Herstellung von Rohren und Hohlprofilen aus zugekauftem Stahl',
    },
    { value: '331221', label: 'Herstellung von gewalzten Stahlprofilen' },
    { value: '331222', label: 'Herstellung von Stahldraht' },
  ],
  [ALUMINA_AND_ALUMINUM_PRODUCTION_INDUSTRY_GROUP]: [
    {
      value: '331313',
      label: 'Aluminaraffination und Herstellung von Primäraluminium',
    },
    {
      value: '331314',
      label: 'Sekundärschmelzen und Legieren von Aluminium',
    },
    {
      value: '331315',
      label: 'Herstellung von Aluminiumblechen, -platten und -folien',
    },
    {
      value: '331318',
      label: 'Sonstiges Walzen, Ziehen und Pressen von Aluminium',
    },
  ],
  [NONFERROUS_METAL_PRODUCTION_INDUSTRY_GROUP]: [
    {
      value: '33141',
      label: 'Schmelzen und Raffination von Nichteisenmetallen (ohne Aluminium)',
    },
    {
      value: '33142',
      label: 'Walzen, Ziehen, Pressen und Legieren von Kupfer',
    },
    {
      value: '331491',
      label: 'Walzen, Ziehen und Pressen von Nichteisenmetallen (ohne Kupfer und Aluminium)',
    },
    {
      value: '331492',
      label: 'Sekundärschmelzen, Raffination und Legieren von Nichteisenmetallen (ohne Kupfer und Aluminium)',
    },
  ],
  [FOUNDRIES_INDUSTRY_GROUP]: [
    { value: '331511', label: 'Eisengießereien' },
    { value: '331512', label: 'Stahlfeingießereien' },
    { value: '331513', label: 'Stahlgießereien (ohne Feinguss)' },
    { value: '331523', label: 'Druckgießereien für Nichteisenmetalle' },
    { value: '331524', label: 'Aluminiumgießereien (ohne Druckguss)' },
    {
      value: '331529',
      label: 'Sonstige Nichteisengießereien (ohne Druckguss)',
    },
  ],
  [FORGING_AND_STAMPING_INDUSTRY_GROUP]: [
    { value: '332111', label: 'Schmieden von Eisen und Stahl' },
    { value: '332112', label: 'Schmieden von Nichteisenmetallen' },
    { value: '332114', label: 'Profilwalzen im Lohn (Custom Roll Forming)' },
    {
      value: '332117',
      label: 'Herstellung von pulvermetallurgischen Formteilen',
    },
    {
      value: '332119',
      label: 'Stanzen von Metallkronen, Verschlüssen und sonstigen Metallteilen (ohne Kfz-Bereich)',
    },
  ],
  [CUTLERY_AND_HANDTOOL_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '332215',
      label: 'Herstellung von Metallkochgeschirr, Bestecken, Messern und Tafelgeräten (ohne Edelmetalle)',
    },
    { value: '332216', label: 'Herstellung von Sägeblättern und Handwerkzeugen' },
  ],
  [ARCHITECTURAL_METALS_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '332311',
      label: 'Herstellung von vorgefertigten Metallgebäuden und -bauteilen',
    },
    { value: '332312', label: 'Herstellung von metallischen Tragkonstruktionen' },
    { value: '332313', label: 'Herstellung von Blech- und Behälterkonstruktionen' },
    { value: '332321', label: 'Herstellung von Metallfenstern und -türen' },
    { value: '332322', label: 'Herstellung von Blechwaren' },
    {
      value: '332323',
      label: 'Herstellung von Zier- und Architekturmetallwaren',
    },
  ],
  [BOILERS_TANK_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '33241',
      label: 'Herstellung von Dampfkesseln und Wärmetauschern',
    },
    {
      value: '33242',
      label: 'Herstellung von schweren Metalltanks und -behältern',
    },
    { value: '332431', label: 'Herstellung von Metalldosen' },
    { value: '332439', label: 'Sonstige Herstellung von Metallbehältern' },
  ],
  [HARDWARE_MANUFACTURING_INDUSTRY_GROUP]: [],
  [SPRING_AND_WIRE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '332613', label: 'Herstellung von Federn' },
    {
      value: '332618',
      label: 'Sonstige Herstellung von Drahtwaren',
    },
  ],
  [MACHINE_SHOPS_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33271', label: 'Werkzeug- und Maschinenbaubetriebe (Dreh- und Fräsereien)' },
    {
      value: '332721',
      label: 'Herstellung von Präzisionsdrehteilen',
    },
    {
      value: '332722',
      label: 'Herstellung von Schrauben, Muttern, Nieten, Bolzen und Unterlegscheiben',
    },
  ],
  [COATING_ENGRAVING_HEAT_TREATING_INDUSTRY_GROUP]: [
    { value: '332811', label: 'Wärmebehandlung von Metallen' },
    {
      value: '332812',
      label:
        'Beschichten und Gravieren von Metallen (ohne Schmuck/Silberwaren) sowie sonstige Veredelungsdienste für Hersteller',
    },
    {
      value: '332813',
      label: 'Galvanisieren, Plattieren, Polieren, Anodisieren und Färben von Metall',
    },
  ],
  [OTHER_FABRICATED_TOOL_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '332911', label: 'Herstellung von Industriearmaturen' },
    {
      value: '332912',
      label: 'Herstellung von Fluidtechnik-Ventilen und -Schlaucharmaturen',
    },
    {
      value: '332913',
      label: 'Herstellung von Armaturen und Beschlägen für Sanitärinstallationen',
    },
    {
      value: '332919',
      label: 'Herstellung sonstiger Metallventile und Rohrarmaturen',
    },
    {
      value: '332991',
      label: 'Herstellung von Kugel- und Wälzlagern',
    },
    { value: '332992', label: 'Herstellung von Munition für Handfeuerwaffen' },
    {
      value: '332993',
      label: 'Herstellung von Munition (ohne Handfeuerwaffenmunition)',
    },
    {
      value: '332994',
      label: 'Herstellung von Handfeuerwaffen, Geschützen und zugehörigen Ausrüstungen',
    },
    {
      value: '332996',
      label: 'Herstellung von vorgefertigten Rohren und Rohrleitungen',
    },
    {
      value: '332999',
      label: 'Sonstige Herstellung von Metallwaren (verschiedenartige Metallkonstruktionen und -produkte)',
    },
  ],
  [AGRICULTURE_CONSTRUCTION_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '333111',
      label: 'Herstellung von landwirtschaftlichen Maschinen und Geräten',
    },
    {
      value: '333112',
      label: 'Herstellung von Rasen- und Gartentraktoren sowie sonstigen Haus- und Gartengeräten',
    },
    { value: '33312', label: 'Herstellung von Baumaschinen' },
    {
      value: '333131',
      label: 'Herstellung von Bergbau- und Gewinnungsmaschinen',
    },
    {
      value: '333132',
      label: 'Herstellung von Ausrüstungen und Maschinen für Öl- und Gasfelder',
    },
  ],
  [INDUSTRIAL_MACHINERY_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '333241',
      label: 'Herstellung von Nahrungsmittelverarbeitungsmaschinen',
    },
    {
      value: '333242',
      label: 'Herstellung von Maschinen für die Halbleiterfertigung',
    },
    {
      value: '333243',
      label: 'Herstellung von Sägewerks-, Holz- und Papiermaschinen',
    },
    {
      value: '333248',
      label: 'Sonstige Herstellung von industriellen Maschinen',
    },
  ],
  [COMMERCIAL_AND_SERVICE_INDUSTRY_MANUFACTURING_INDUSTRY_GROUP]: [],
  [VENTILATION_HEATING_AIR_CONDITIONING_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '333413',
      label: 'Herstellung von Industrie- und Gewerbelüftern, Gebläsen und Luftreinigungsgeräten',
    },
    {
      value: '333414',
      label: 'Herstellung von Heizgeräten (ohne Warmluftheizungen)',
    },
    {
      value: '333415',
      label: 'Herstellung von Klima- und Warmluftheizgeräten sowie gewerblichen und industriellen Kühlgeräten',
    },
  ],
  [METALWORKING_MACHINERY_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '333511', label: 'Herstellung von Formen und Werkzeugen (Industrieformenbau)' },
    {
      value: '333514',
      label: 'Herstellung von Spezialwerkzeugen, Matrizen, Vorrichtungen und Lehren',
    },
    {
      value: '333515',
      label: 'Herstellung von Schneidwerkzeugen und Zubehör für Werkzeugmaschinen',
    },
    { value: '333517', label: 'Herstellung von Werkzeugmaschinen' },
    {
      value: '333519',
      label: 'Herstellung von Walzwerken und sonstigen Metallbearbeitungsmaschinen',
    },
  ],
  [ENGINE_TURBINE_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '333611',
      label: 'Herstellung von Turbinen und Turbinengenerator-Einheiten',
    },
    {
      value: '333612',
      label: 'Herstellung von Getrieben, Drehzahlwandlern und sonstigen Hochgeschwindigkeitsantrieben',
    },
    {
      value: '333613',
      label: 'Herstellung von mechanischen Kraftübertragungsgeräten',
    },
    {
      value: '333618',
      label: 'Herstellung sonstiger Motoren und Antriebsaggregate',
    },
  ],
  [OTHER_GENERAL_PURPOSE_MACHINERY_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33391', label: 'Herstellung von Pumpen und Kompressoren' },
    { value: '333912', label: 'Herstellung von Luft- und Gaskompressoren' },
    {
      value: '333914',
      label: 'Herstellung von Mess-, Dosier- und sonstigen Pumpen und Pumpanlagen',
    },
    {
      value: '333921',
      label: 'Herstellung von Aufzügen und Fahrtreppen',
    },
    {
      value: '333922',
      label: 'Herstellung von Förderern und Förderanlagen',
    },
    {
      value: '333923',
      label: 'Herstellung von Laufkranen, Hebezeugen und Einschienenkrananlagen',
    },
    {
      value: '333924',
      label: 'Herstellung von Flurförderzeugen, Industriefahrzeugen, Anhängern und Staplern',
    },
    {
      value: '333991',
      label: 'Herstellung von motorbetriebenen Handwerkzeugen',
    },
    {
      value: '333992',
      label: 'Herstellung von Schweiß- und Lötgeräten',
    },
    {
      value: '333993',
      label: 'Herstellung von Verpackungsmaschinen',
    },
    {
      value: '333994',
      label: 'Herstellung von Industrieöfen und -anlagen zur Wärmebehandlung',
    },
    {
      value: '333995',
      label: 'Herstellung von Fluidtechnik-Zylindern und -Aktoren',
    },
    {
      value: '333996',
      label: 'Herstellung von Fluidtechnikpumpen und -motoren',
    },
    {
      value: '333998',
      label: 'Sonstige Herstellung von allgemeinen Maschinen und Aggregaten',
    },
  ],
  [COMPUTER_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '334111', label: 'Herstellung von elektronischen Datenverarbeitungsanlagen' },
    { value: '334112', label: 'Herstellung von Datenspeichergeräten' },
    {
      value: '334118',
      label: 'Herstellung von Computerterminals und sonstigen Computerperipheriegeräten',
    },
  ],
  [COMMUNICATION_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33421', label: 'Herstellung von Telefonapparaten' },
    {
      value: '33422',
      label: 'Herstellung von Funk- und Rundfunktechnik sowie drahtlosen Kommunikationsgeräten',
    },
    {
      value: '33429',
      label: 'Sonstige Herstellung von Kommunikationsgeräten',
    },
  ],
  [AUDIO_VIDEO_MANUFACTURING_INDUSTRY_GROUP]: [],
  [SEMICONDUCTOR_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '334412',
      label: 'Herstellung von unbestückten Leiterplatten',
    },
    {
      value: '334413',
      label: 'Herstellung von Halbleitern und verwandten Bauelementen',
    },
    {
      value: '334416',
      label: 'Herstellung von Kondensatoren, Widerständen, Spulen, Transformatoren und sonstigen Induktivitäten',
    },
    {
      value: '334417',
      label: 'Herstellung von elektrischen Steckverbindern',
    },
    {
      value: '334418',
      label: 'Herstellung von bestückten Leiterplatten (elektronische Baugruppenfertigung)',
    },
    {
      value: '334419',
      label: 'Sonstige Herstellung elektronischer Bauelemente',
    },
  ],
  [NAVIGATIONAL_INSTRUMENTS_INDUSTRY_GROUP]: [
    {
      value: '334510',
      label: 'Herstellung von elektromedizinischen und elektrotherapeutischen Geräten',
    },
    {
      value: '334511',
      label: 'Herstellung von Such-, Ortungs-, Navigations-, Leitsystemen und Luft- und Seefahrtinstrumenten',
    },
    {
      value: '334512',
      label: 'Herstellung von automatischen Regel- und Steuergeräten für Gebäude, Anlagen und Haushaltsgeräte',
    },
    {
      value: '334513',
      label: 'Herstellung von Mess- und Anzeigeinstrumenten für industrielle Prozessgrößen',
    },
    {
      value: '334514',
      label: 'Herstellung von Durchflussmessern und Zählgeräten für Flüssigkeiten',
    },
    {
      value: '334515',
      label: 'Herstellung von Mess- und Prüfgeräten für elektrische Größen und Signale',
    },
    {
      value: '334516',
      label: 'Herstellung von Analyse- und Laborinstrumenten',
    },
    {
      value: '334517',
      label: 'Herstellung von Bestrahlungsanlagen',
    },
    {
      value: '334519',
      label: 'Sonstige Herstellung von Mess- und Regelgeräten',
    },
  ],
  [MANUFACTURING_AND_REPRODUCING_MAGNETIC_AND_OPTICAL_MEDIA_INDUSTRY_GROUP]: [],
  [ELECTRIC_LIGHTING_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '335131',
      label: 'Herstellung von elektrischen Wohnraumleuchten',
    },
    {
      value: '335132',
      label: 'Herstellung von elektrischen Leuchten für Gewerbe, Industrie und öffentliche Einrichtungen',
    },
    {
      value: '335139',
      label: 'Herstellung von Lampen und sonstigen Beleuchtungsgeräten',
    },
  ],
  [HOUSEHOLD_APPLIANCE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33521', label: 'Herstellung von kleinen Elektrohaushaltsgeräten' },
    { value: '33522', label: 'Herstellung von großen Haushaltsgeräten' },
  ],
  [ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '335311',
      label: 'Herstellung von Leistungs-, Verteil- und Spezialtransformatoren',
    },
    { value: '335312', label: 'Herstellung von Elektromotoren und Generatoren' },
    {
      value: '335313',
      label: 'Herstellung von Schaltanlagen und Schaltgeräten',
    },
    {
      value: '335314',
      label: 'Herstellung von Relais und industriellen Steuergeräten',
    },
  ],
  [OTHER_ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33591', label: 'Batterieherstellung' },
    { value: '335921', label: 'Herstellung von Lichtwellenleiterkabeln' },
    {
      value: '335929',
      label: 'Herstellung sonstiger Kommunikations- und Energiekabel',
    },
    { value: '33593', label: 'Herstellung von Installationsmaterial und Steckvorrichtungen' },
    {
      value: '335991',
      label: 'Herstellung von Kohlenstoff- und Graphitprodukten',
    },
    {
      value: '335999',
      label: 'Sonstige Herstellung elektrischer Ausrüstungen und Komponenten',
    },
  ],
  [MOTOR_VEHICLE_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '33611',
      label: 'Herstellung von Personenkraftwagen und leichten Nutzfahrzeugen',
    },
    { value: '33612', label: 'Herstellung von schweren Nutzfahrzeugen' },
  ],
  [VEHICLE_BODY_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '336211', label: 'Herstellung von Karosserien für Kraftfahrzeuge' },
    { value: '336212', label: 'Herstellung von Anhängern' },
    { value: '336213', label: 'Herstellung von Wohnmobilen' },
    { value: '336214', label: 'Herstellung von Wohnwagen und Campinganhängern' },
  ],
  [VEHICLE_PARTS_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '33631',
      label: 'Herstellung von Ottomotoren und Motorteilen für Kraftfahrzeuge',
    },
    {
      value: '33632',
      label: 'Herstellung von elektrischen und elektronischen Kfz-Komponenten',
    },
    {
      value: '33633',
      label: 'Herstellung von Lenkungs- und Fahrwerkskomponenten für Kraftfahrzeuge (ohne Federn)',
    },
    { value: '33634', label: 'Herstellung von Bremsanlagen für Kraftfahrzeuge' },
    {
      value: '33635',
      label: 'Herstellung von Getrieben und Antriebskomponenten für Kraftfahrzeuge',
    },
    {
      value: '33636',
      label: 'Herstellung von Fahrzeugsitzen und Innenausstattungen',
    },
    { value: '33637', label: 'Metallstanzen für Kraftfahrzeuge' },
    {
      value: '33639',
      label: 'Sonstige Herstellung von Kraftfahrzeugteilen',
    },
  ],
  [AEROSPACE_PRODUCT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '336411', label: 'Herstellung von Flugzeugen' },
    {
      value: '336412',
      label: 'Herstellung von Flugtriebwerken und Triebwerksteilen',
    },
    {
      value: '336413',
      label: 'Herstellung sonstiger Flugzeugteile und -ausrüstung',
    },
    {
      value: '336414',
      label: 'Herstellung von Raketen und Raumfahrzeugen',
    },
    {
      value: '336415',
      label: 'Herstellung von Antrieben und Antriebsteilen für Raketen und Raumfahrzeuge',
    },
    {
      value: '336419',
      label: 'Herstellung sonstiger Teile und Ausrüstung für Raketen und Raumfahrzeuge',
    },
  ],
  [RAILROAD_MANUFACTURING_INDUSTRY_GROUP]: [],
  [SHIP_AND_BOAT_BUILDING_INDUSTRY_GROUP]: [
    { value: '336611', label: 'Schiffbau und Schiffsreparatur' },
    { value: '336612', label: 'Bootsbau' },
  ],
  [OTHER_TRANSPORTATION_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '336991',
      label: 'Herstellung von Motorrädern, Fahrrädern und deren Teilen',
    },
    {
      value: '336992',
      label: 'Herstellung von gepanzerten Militärfahrzeugen und Panzern',
    },
    {
      value: '336999',
      label: 'Sonstige Herstellung von Verkehrsmitteln',
    },
  ],
  [HOUSEHOLD_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '33711',
      label: 'Herstellung von Küchenmöbeln und Arbeitsplatten aus Holz',
    },
    {
      value: '337121',
      label: 'Herstellung von gepolsterten Wohnraummöbeln',
    },
    {
      value: '337122',
      label: 'Herstellung von nicht gepolsterten Wohnraummöbeln aus Holz',
    },
    {
      value: '337126',
      label: 'Herstellung von Wohnraummöbeln (ohne Holz und Polstermöbel)',
    },
    {
      value: '337127',
      label: 'Herstellung von Möbeln für Institutionen',
    },
  ],
  [OFFICE_FURNITURE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '337211', label: 'Herstellung von Büromöbeln aus Holz' },
    {
      value: '337212',
      label: 'Herstellung von maßgefertigten Innenausbauten und Holzverkleidungen',
    },
    {
      value: '337214',
      label: 'Herstellung von Büromöbeln (ohne Holzmöbel)',
    },
    {
      value: '337215',
      label: 'Herstellung von Vitrinen, Trennwänden, Regalen und Spinden',
    },
  ],
  [OTHER_FURNITURE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33791', label: 'Matratzenherstellung' },
    { value: '33792', label: 'Herstellung von Jalousien und Rollos' },
  ],
  [MEDICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '339112', label: 'Herstellung von chirurgischen und medizinischen Instrumenten' },
    {
      value: '339113',
      label: 'Herstellung von chirurgischen Geräten und medizinischen Verbrauchsartikeln',
    },
    {
      value: '339114',
      label: 'Herstellung von zahnärztlichen Geräten und Bedarfsmitteln',
    },
    { value: '339115', label: 'Herstellung von optischen Erzeugnissen (Augenoptik)' },
    { value: '339116', label: 'Zahntechnische Labore' },
  ],
  [OTHER_MISCELLANEOUS_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33991', label: 'Herstellung von Schmuck und Silberwaren' },
    {
      value: '33992',
      label: 'Herstellung von Sport- und Freizeitartikeln',
    },
    {
      value: '33993',
      label: 'Herstellung von Puppen, Spielzeug und Spielen',
    },
    {
      value: '33994',
      label: 'Herstellung von Bürobedarf (ohne Papierwaren)',
    },
    { value: '33995', label: 'Schilderherstellung' },
    {
      value: '339991',
      label: 'Herstellung von Dichtungen, Packungen und Abdichtungselementen',
    },
    { value: '339992', label: 'Herstellung von Musikinstrumenten' },
    {
      value: '339993',
      label: 'Herstellung von Knöpfen, Nadeln, Steck- und Befestigungsteilen',
    },
    {
      value: '339994',
      label: 'Herstellung von Besen, Bürsten und Wischgeräten',
    },
    { value: '339995', label: 'Herstellung von Särgen' },
    {
      value: '339999',
      label: 'Sonstige Herstellung von verschiedenartigen Erzeugnissen',
    },
  ],
  [PRINTING_MANUFACTURING_SUB_SECTOR]: [
    {
      value: '323111',
      label: 'Gewerblicher Druck (ohne Siebdruck und Buchdruck)',
    },
    { value: '323113', label: 'Gewerblicher Siebdruck' },
    { value: '323117', label: 'Buchdruck/Herstellung von Büchern' },
    { value: '32312', label: 'Vor- und nachgelagerte Dienste für die Druckindustrie' },
  ],
  [PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR]: [
    { value: '32411', label: 'Erdölraffinerien' },
    {
      value: '324121',
      label: 'Herstellung von Asphaltmischgut und Asphaltblöcken',
    },
    {
      value: '324122',
      label: 'Herstellung von Dachschindeln und bituminösen Beschichtungsmaterialien',
    },
    {
      value: '324191',
      label: 'Herstellung von Schmierölen und -fetten aus Erdöl',
    },
    {
      value: '324199',
      label: 'Sonstige Herstellung von Erzeugnissen aus Erdöl und Kohle',
    },
  ],
  [MOTOR_VEHICLE_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42311',
      label: 'Großhandel mit Personenkraftwagen und sonstigen Kraftfahrzeugen',
    },
    {
      value: '42312',
      label: 'Großhandel mit Kraftfahrzeugteilen und -zubehör (Neuteile)',
    },
    {
      value: '42313',
      label: 'Großhandel mit Reifen und Schläuchen',
    },
    {
      value: '42314',
      label: 'Großhandel mit gebrauchten Kraftfahrzeugteilen',
    },
  ],
  [FURNITURE_AND_HONE_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42321', label: 'Großhandel mit Möbeln' },
    {
      value: '42322',
      label: 'Großhandel mit Heimtextilien und Wohnaccessoires',
    },
  ],
  [LUMBER_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42331',
      label: 'Großhandel mit Schnittholz, Sperrholz, Holzbauteilen und Holzplatten',
    },
    {
      value: '42332',
      label: 'Großhandel mit Ziegeln, Naturstein und sonstigen Baustoffen',
    },
    {
      value: '42333',
      label: 'Großhandel mit Dachdeckungs-, Fassaden- und Dämmmaterial',
    },
    {
      value: '42339',
      label: 'Großhandel mit sonstigen Baustoffen',
    },
  ],

  [PROF_AND_COMMERCIAL_EQUIPMENT_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42341',
      label: 'Großhandel mit fotografischen Geräten und Bedarfsartikeln',
    },
    {
      value: '42342',
      label: 'Großhandel mit Büroausstattung und -geräten',
    },
    {
      value: '42343',
      label: 'Großhandel mit Computern, Computerperipheriegeräten und Software',
    },
    {
      value: '42344',
      label: 'Großhandel mit sonstigen gewerblichen Geräten',
    },
    {
      value: '42345',
      label: 'Großhandel mit medizinischen, zahnärztlichen und Krankenhauseinrichtungen und -bedarf',
    },
    {
      value: '42346',
      label: 'Großhandel mit augenoptischen Erzeugnissen',
    },
    {
      value: '42349',
      label: 'Großhandel mit sonstigen professionellen Geräten und Bedarfsartikeln',
    },
  ],
  [METAL_AND_MINERAL_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42351',
      label: 'Metallservicezentren und sonstiger Metallgroßhandel',
    },
    {
      value: '42352',
      label: 'Großhandel mit Kohle sowie anderen Mineralien und Erzen',
    },
  ],
  [HOUSEHOLD_APPLIANCES_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42361',
      label: 'Großhandel mit elektrischen Geräten, Installationsmaterial und zugehöriger Ausrüstung',
    },
    {
      value: '42362',
      label: 'Großhandel mit Haushaltsgroß- und -kleingeräten sowie Unterhaltungselektronik',
    },
    {
      value: '42369',
      label: 'Großhandel mit sonstigen elektronischen Bauteilen und Geräten',
    },
  ],
  [HARDWARE_AND_PLUMBING_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42371',
      label: 'Großhandel mit Eisenwaren',
    },
    {
      value: '42372',
      label: 'Großhandel mit Sanitär- und Heizungsbedarf (Hydronik)',
    },
    {
      value: '42373',
      label: 'Großhandel mit Warmluftheizungs- und Klimageräten sowie Zubehör',
    },
    {
      value: '42374',
      label: 'Großhandel mit Kälte- und Kühltechnik sowie Zubehör',
    },
  ],
  [MACHINERY_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42381',
      label: 'Großhandel mit Bau- und Bergbaumaschinen (ohne Bohrgeräte für Ölquellen)',
    },
    {
      value: '42382',
      label: 'Großhandel mit Land- und Gartenmaschinen',
    },
    {
      value: '42383',
      label: 'Großhandel mit Industriemaschinen und -anlagen',
    },
    {
      value: '42384',
      label: 'Großhandel mit Industriebedarf',
    },
    {
      value: '42385',
      label: 'Großhandel mit Ausstattungen und Bedarf für Dienstleistungsbetriebe',
    },
    {
      value: '42386',
      label: 'Großhandel mit Transportausrüstung und -bedarf (ohne Kraftfahrzeuge)',
    },
  ],
  [MISCELLANEOUS_DURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42391',
      label: 'Großhandel mit Sport- und Freizeitartikeln',
    },
    {
      value: '42392',
      label: 'Großhandel mit Spielwaren und Hobbyartikeln',
    },
    {
      value: '42393',
      label: 'Großhandel mit Recyclingmaterialien',
    },
    {
      value: '42394',
      label: 'Großhandel mit Schmuck, Uhren, Edelsteinen und Edelmetallen',
    },
    {
      value: '42399',
      label: 'Großhandel mit sonstigen langlebigen Gebrauchsgütern',
    },
  ],
  [PAPER_AND_PRODUCT_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42411',
      label: 'Großhandel mit Druck- und Schreibpapier',
    },
    {
      value: '42412',
      label: 'Großhandel mit Schreibwaren und Bürobedarf',
    },
    {
      value: '42413',
      label: 'Großhandel mit Industrie- und Hygienepapier',
    },
  ],
  [DRUGS_WHOLESALERS_INDUSTRY_GROUP]: [],
  [APPAREL_PIECE_GOODS_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42431',
      label: 'Großhandel mit Meterwaren, Kurzwaren und sonstigen Textilwaren',
    },
    {
      value: '42434',
      label: 'Großhandel mit Schuhen',
    },
    {
      value: '42435',
      label: 'Großhandel mit Bekleidung und Bekleidungsaccessoires',
    },
  ],
  [GROCERY_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42441',
      label: 'Großhandel mit gemischten Lebensmitteln',
    },
    {
      value: '42442',
      label: 'Großhandel mit tiefgekühlten Lebensmitteln',
    },
    {
      value: '42443',
      label: 'Großhandel mit Milch- und Molkereiprodukten (ohne Trocken- oder Dosenware)',
    },
    {
      value: '42444',
      label: 'Großhandel mit Geflügel und Geflügelprodukten',
    },
    {
      value: '42445',
      label: 'Großhandel mit Süßwaren',
    },
    {
      value: '42446',
      label: 'Großhandel mit Fisch und Meeresfrüchten',
    },
    {
      value: '42447',
      label: 'Großhandel mit Fleisch und Fleischwaren',
    },
    {
      value: '42448',
      label: 'Großhandel mit frischem Obst und Gemüse',
    },
    {
      value: '42449',
      label: 'Großhandel mit sonstigen Lebensmitteln und verwandten Produkten',
    },
  ],
  [FARM_PRODUCT_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42451',
      label: 'Großhandel mit Getreide und Feldbohnen',
    },
    {
      value: '42452',
      label: 'Großhandel mit lebendem Vieh',
    },
    {
      value: '42459',
      label: 'Großhandel mit sonstigen landwirtschaftlichen Rohstoffen',
    },
  ],
  [CHEMICAL_AND_ALLIED_PRODUCTS_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42461',
      label: 'Großhandel mit Kunststoffen in Primärformen, Halbzeugen und Grundformen',
    },
    {
      value: '42469',
      label: 'Großhandel mit sonstigen chemischen Erzeugnissen',
    },
  ],
  [PETROLEUM_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42471',
      label: 'Mineralölgroßhandelstanklager und Terminals',
    },
    {
      value: '42472',
      label: 'Großhandel mit Mineralöl und Mineralölprodukten (ohne Tanklager und Terminals)',
    },
  ],
  [BEER_WINE_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42481',
      label: 'Großhandel mit Bier und Ale',
    },
    {
      value: '42482',
      label: 'Großhandel mit Wein und Spirituosen',
    },
  ],
  [MISCELLANEOUS_NONDURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42491',
      label: 'Großhandel mit landwirtschaftlichem Bedarf',
    },
    {
      value: '42492',
      label: 'Großhandel mit Büchern, Zeitschriften und Zeitungen',
    },
    {
      value: '42493',
      label: 'Großhandel mit Schnittblumen, Zierpflanzen und Floristikbedarf',
    },
    {
      value: '42494',
      label: 'Großhandel mit Tabakwaren und E-Zigaretten',
    },
    {
      value: '42495',
      label: 'Großhandel mit Farben, Lacken und Malerbedarf',
    },
    {
      value: '42499',
      label: 'Großhandel mit sonstigen kurzlebigen Konsumgütern',
    },
  ],
  [AGENTS_AND_BROKERS_SUB_SECTOR]: [],
  [AUTO_DEALERS_INDUSTRY_GROUP]: [
    {
      value: '44111',
      label: 'Vertragshändler für Neuwagen',
    },
    {
      value: '44112',
      label: 'Gebrauchtwagenhändler',
    },
  ],
  [OTHER_MOTOR_DEALERS_INDUSTRY_GROUP]: [
    {
      value: '44121',
      label: 'Händler für Freizeitfahrzeuge',
    },
    {
      value: '441222',
      label: 'Bootshändler',
    },
    {
      value: '441227',
      label: 'Händler für Motorräder, ATVs und sonstige Motorfahrzeuge',
    },
  ],
  [AUTOMOTIVE_PARTS_INDUSTRY_GROUP]: [
    {
      value: '44133',
      label: 'Einzelhändler für Kfz-Teile und -Zubehör',
    },
    {
      value: '44134',
      label: 'Reifenhändler',
    },
  ],
  [BUILDING_MATERIAL_AND_SUPPLIES_DEALERS_INDUSTRY_GROUP]: [
    {
      value: '44411',
      label: 'Bau- und Heimwerkermärkte',
    },
    {
      value: '44412',
      label: 'Farben- und Tapeteneinzelhändler',
    },
    {
      value: '44414',
      label: 'Eisenwaren-Einzelhändler',
    },
    {
      value: '44418',
      label: 'Sonstige Baustoffhändler',
    },
  ],
  [LAWN_AND_GARDEN_EQUIPMENT_INDUSTRY_GROUP]: [
    {
      value: '44423',
      label: 'Einzelhändler für motorbetriebene Gartengeräte',
    },
    {
      value: '44424',
      label: 'Gartencenter- und Landhandels-Einzelhändler',
    },
  ],
  [GROCERY_RETAILERS_INDUSTRY_GROUP]: [
    {
      value: '44511',
      label: 'Supermärkte und sonstige Lebensmitteleinzelhändler (ohne Convenience-Shops)',
    },
    {
      value: '445131',
      label: 'Convenience-Shops',
    },
    {
      value: '445132',
      label: 'Betreiber von Verkaufsautomaten',
    },
  ],
  [SPECIALTY_FOOD_RETAILERS_INDUSTRY_GROUP]: [
    {
      value: '44523',
      label: 'Obst- und Gemüseeinzelhändler',
    },
    {
      value: '44524',
      label: 'Fleischeinzelhändler',
    },
    {
      value: '44525',
      label: 'Fisch- und Meeresfrüchteeinzelhändler',
    },
    {
      value: '445291',
      label: 'Bäckerei- und Backwareneinzelhändler',
    },
    {
      value: '445292',
      label: 'Süßwaren- und Nusswareneinzelhändler',
    },
    {
      value: '445298',
      label: 'Sonstige Facheinzelhändler für Lebensmittel',
    },
  ],
  [BEER_WINE_LIQUOR_RETAILERS_INDUSTRY_GROUP]: [],
  [FURNITURE_RETAILERS_INDUSTRY_GROUP]: [
    {
      value: '44911',
      label: 'Möbeleinzelhändler',
    },
    {
      value: '449121',
      label: 'Bodenbelags-Einzelhändler',
    },
    {
      value: '449122',
      label: 'Einzelhändler für Fensterdekorationen',
    },
    {
      value: '449129',
      label: 'Sonstige Einzelhändler für Wohnaccessoires',
    },
  ],
  [ELECTRONICS_RETAILERS_INDUSTRY_GROUP]: [],
  [DEPARTMENT_STORE_INDUSTRY_GROUP]: [],
  [WAREHOUSE_CLUBS_RETAILERS_INDUSTRY_GROUP]: [
    {
      value: '455211',
      label: 'Warenlagerclubs und Großflächenmärkte',
    },
    {
      value: '455219',
      label: 'Sonstige Einzelhändler für gemischte Sortimente',
    },
  ],
  [HEALTH_RETAILERS_SUB_SECTOR]: [
    {
      value: '45611',
      label: 'Apotheken und Drogeriemärkte',
    },
    {
      value: '45612',
      label: 'Einzelhändler für Kosmetik, Schönheits- und Parfümeriewaren',
    },
    {
      value: '45613',
      label: 'Augenoptik- und Brilleneinzelhändler',
    },
    {
      value: '456191',
      label: 'Einzelhändler für Nahrungsergänzungs- und Gesundheitsprodukte',
    },
    {
      value: '456199',
      label: 'Sonstige Einzelhändler für Gesundheits- und Körperpflegeprodukte',
    },
  ],
  [GASOLINE_STATIONS_INDUSTRY_GROUP]: [
    {
      value: '45711',
      label: 'Tankstellen mit Convenience-Shop',
    },
    {
      value: '45712',
      label: 'Sonstige Tankstellen',
    },
  ],
  [FUEL_DEALERS_INDUSTRY_GROUP]: [],
  [CLOTHING_RETAILERS_INDUSTRY_GROUP]: [],
  [SHOE_RETAILERS_INDUSTRY_GROUP]: [],
  [JEWELRY_RETAILERS_INDUSTRY_GROUP]: [
    {
      value: '45831',
      label: 'Juweliereinzelhändler',
    },
    {
      value: '45832',
      label: 'Einzelhändler für Reisegepäck und Lederwaren',
    },
  ],
  [SPORTING_GOODS_RETAILERS_INDUSTRY_GROUP]: [
    {
      value: '45911',
      label: 'Sportfachhandel',
    },
    {
      value: '45912',
      label: 'Hobby-, Spielwaren- und Spiele-Einzelhändler',
    },
    {
      value: '45913',
      label: 'Einzelhändler für Näh-, Handarbeits- und Meterwaren',
    },
    {
      value: '45914',
      label: 'Musikinstrumenten- und Zubehör-Einzelhändler',
    },
  ],
  [BOOK_RETAILERS_INDUSTRY_GROUP]: [],
  [FLORISTS_INDUSTRY_GROUP]: [],
  [OFFICE_SUPPLY_RETAILERS_INDUSTRY_GROUP]: [
    {
      value: '45941',
      label: 'Bürobedarfs- und Schreibwareneinzelhändler',
    },
    {
      value: '45942',
      label: 'Geschenk-, Deko- und Souvenir-Einzelhändler',
    },
  ],
  [USED_MERCHANDISE_INDUSTRY_GROUP]: [],
  [OTHER_MISCELLANEOUS_INDUSTRY_GROUP]: [
    {
      value: '45991',
      label: 'Zoofachhandel und Tierbedarfs-Einzelhändler',
    },
    {
      value: '45992',
      label: 'Kunsthändler',
    },
    {
      value: '45993',
      label: 'Händler für Fertig- und Mobilheime',
    },
    {
      value: '45999',
      label: 'Sonstige Facheinzelhändler',
    },
    {
      value: '459991',
      label: 'Einzelhändler für Tabak, E-Zigaretten und sonstige Rauchbedarfsartikel',
    },
  ],
  [SCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP]: [
    {
      value: '481111',
      label: 'Linienflugverkehr für Passagiere',
    },
    {
      value: '481112',
      label: 'Linienflugverkehr für Fracht',
    },
  ],
  [NONSCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP]: [
    {
      value: '481211',
      label: 'Gecharterter Passagierflugverkehr (nicht planmäßig)',
    },
    {
      value: '481212',
      label: 'Gecharterter Frachtflugverkehr (nicht planmäßig)',
    },
    {
      value: '481219',
      label: 'Sonstiger nicht planmäßiger Luftverkehr',
    },
  ],
  [DEEP_SEA_TRANSPORTATION_INDUSTRY_GROUP]: [
    {
      value: '483111',
      label: 'Hochseefrachtverkehr',
    },
    {
      value: '483112',
      label: 'Hochseepersonenverkehr',
    },
    {
      value: '483113',
      label: 'Küsten- und Binnensee-Frachtverkehr',
    },
    {
      value: '483114',
      label: 'Küsten- und Binnensee-Personenverkehr',
    },
  ],
  [INLAND_WATER_TRANSPORTATION_INDUSTRY_GROUP]: [
    {
      value: '483211',
      label: 'Binnenschifffahrts-Frachtverkehr',
    },
    {
      value: '483212',
      label: 'Binnenschifffahrts-Personenverkehr',
    },
  ],
  [GENERAL_FREIGHT_TRUCKING_INDUSTRY_GROUP]: [
    {
      value: '48411',
      label: 'Nahgüterverkehr mit Lkw',
    },
    {
      value: '484121',
      label: 'Fernverkehr mit Lkw, Komplettladungen',
    },
    {
      value: '484122',
      label: 'Fernverkehr mit Lkw, Stückgut/Teilladungen',
    },
  ],
  [SPECIALIZED_FREIGHT_TRUCKING_INDUSTRY_GROUP]: [
    {
      value: '48421',
      label: 'Umzugsdienste für Hausrat und Büroausstattung',
    },
    {
      value: '48422',
      label: 'Nahverkehr mit spezialisierten Gütern (ohne gebrauchte Waren)',
    },
    {
      value: '48423',
      label: 'Fernverkehr mit spezialisierten Gütern (ohne gebrauchte Waren)',
    },
  ],
  [URBAN_TRANSIT_SYSTEMS_INDUSTRY_GROUP]: [
    {
      value: '485111',
      label: 'Verbundverkehrssysteme mit mehreren Verkehrsträgern',
    },
    {
      value: '485112',
      label: 'S-Bahn- und Pendlerzug-Systeme',
    },
    {
      value: '485113',
      label: 'Bus- und sonstige motorisierte Nahverkehrssysteme',
    },
    {
      value: '485119',
      label: 'Sonstige städtische Verkehrssysteme',
    },
  ],
  [INTERURBAN_TRANSPORTATION_INDUSTRY_GROUP]: [],
  [TAXI_SERVICE_INDUSTRY_GROUP]: [
    {
      value: '48531',
      label: 'Taxi- und Ride-Sharing-Dienste',
    },
    {
      value: '48532',
      label: 'Limousinenservice',
    },
  ],
  [SCHOOL_TRANSPORTATION_INDUSTRY_GROUP]: [],
  [CHARTER_BUS_INDUSTRY_GROUP]: [],
  [OTHER_TRANSIT_TRANSPORTATION_INDUSTRY_GROUP]: [
    {
      value: '485991',
      label: 'Behinderten- und Sonderfahrdienste',
    },
    {
      value: '485999',
      label: 'Sonstiger Linien- und Gelegenheitsverkehr an Land',
    },
  ],
  [CRUDE_OIL_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP]: [],
  [NATURAL_GAS_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP]: [],
  [OTHER_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP]: [
    {
      value: '48691',
      label: 'Pipelinebeförderung von Mineralölprodukten',
    },
    {
      value: '48699',
      label: 'Sonstige Pipelinebeförderung',
    },
  ],
  [SCENIC_LAND_INDUSTRY_GROUP]: [],
  [SCENIC_WATER_INDUSTRY_GROUP]: [],
  [SCENIC_OTHER_INDUSTRY_GROUP]: [],
  [SUPPORT_FOR_AIR_TRANSPORTATION_INDUSTRY_GROUP]: [
    {
      value: '48811',
      label: 'Flughafenbetrieb',
    },
    {
      value: '488111',
      label: 'Flugverkehrskontrolle',
    },
    {
      value: '488119',
      label: 'Sonstige Flughafenbetriebsdienste',
    },
    {
      value: '48819',
      label: 'Sonstige Unterstützungsdienste für den Luftverkehr',
    },
  ],
  [SUPPORT_FOR_RAIL_TRANSPORTATION_INDUSTRY_GROUP]: [],
  [SUPPORT_FOR_WATER_TRANSPORTATION_INDUSTRY_GROUP]: [
    {
      value: '48831',
      label: 'Hafen- und Umschlagsbetrieb',
    },
    {
      value: '48832',
      label: 'Umschlag von Seefracht',
    },
    {
      value: '48833',
      label: 'Navigations- und Lotsendienste für die Schifffahrt',
    },
    {
      value: '48839',
      label: 'Sonstige Unterstützungsdienste für die Schifffahrt',
    },
  ],
  [SUPPORT_FOR_ROAD_TRANSPORTATION_INDUSTRY_GROUP]: [
    {
      value: '48841',
      label: 'Abschleppdienste für Kraftfahrzeuge',
    },
    {
      value: '48849',
      label: 'Sonstige Unterstützungsdienste für den Straßenverkehr',
    },
  ],
  [FREIGHT_TRANSPORTATION_AGREEMENT_INDUSTRY_GROUP]: [],
  [OTHER_SUPPORT_TRANSPORTATION_INDUSTRY_GROUP]: [
    {
      value: '488991',
      label: 'Verpackungs- und Kistendienstleistungen',
    },
    {
      value: '488999',
      label: 'Sonstige Unterstützungsdienste für den Verkehr',
    },
  ],
  [COURIER_DELIVERY_INDUSTRY_GROUP]: [],
  [LOCAL_DELIVERY_INDUSTRY_GROUP]: [],
  [MOTION_PICTURE_INDUSTRY_GROUP]: [
    {
      value: '51211',
      label: 'Film- und Videoproduktion',
    },
    {
      value: '51212',
      label: 'Film- und Videovertrieb',
    },
    {
      value: '51213',
      label: 'Filmvorführung',
    },
    {
      value: '51219',
      label: 'Postproduktion und sonstige Film- und Videodienste',
    },
    {
      value: '512191',
      label: 'Fernsehproduktion und sonstige Postproduktionsdienste',
    },
    {
      value: '512199',
      label: 'Sonstige Film- und Videobranchen',
    },
  ],
  [SOUND_INDUSTRY_GROUP]: [
    {
      value: '51223',
      label: 'Musikverlage',
    },
    {
      value: '51224',
      label: 'Tonstudios',
    },
    {
      value: '51225',
      label: 'Produktion und Vertrieb von Tonträgern',
    },
    {
      value: '51229',
      label: 'Sonstige Tonträger- und Tonaufnahmeindustrie',
    },
  ],
  [NEWSPAPER_INDUSTRY_GROUP]: [
    {
      value: '51311',
      label: 'Zeitungsverlage',
    },
    {
      value: '51312',
      label: 'Zeitschriftenverlage',
    },
    {
      value: '51313',
      label: 'Buchverlage',
    },
    {
      value: '51314',
      label: 'Adress- und Verzeichnisverlage',
    },
    {
      value: '513191',
      label: 'Grußkartenverlage',
    },
    {
      value: '513199',
      label: 'Sonstige Verlage',
    },
  ],
  [SOFTWARE_PUBLISHERS_INDUSTRY_GROUP]: [],
  [RADIO_AND_TELEVISION_INDUSTRY_GROUP]: [
    {
      value: '51611',
      label: 'Hörfunksender',
    },
    {
      value: '51612',
      label: 'Fernsehsender',
    },
  ],
  [MEDIA_STREAMING_INDUSTRY_GROUP]: [],
  [WIRED_TELECOMMUNICATIONS_INDUSTRY_GROUP]: [
    {
      value: '517111',
      label: 'Kabelgebundene Telekommunikationsanbieter',
    },
    {
      value: '517112',
      label: 'Drahtlose Telekommunikationsanbieter (ohne Satellit)',
    },
    {
      value: '517121',
      label: 'Wiederverkäufer von Telekommunikationsdiensten',
    },
    {
      value: '517122',
      label: 'Vermittler für drahtlose Telekommunikationsdienste',
    },
  ],
  [SATELLITE_TELECOMMUNICATIONS_INDUSTRY_GROUP]: [],
  [OTHER_TELECOMMUNICATIONS_INDUSTRY_GROUP]: [],
  [DEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP]: [
    {
      value: '52211',
      label: 'Geschäftsbanken',
    },
    {
      value: '52213',
      label: 'Kreditgenossenschaften',
    },
    {
      value: '52218',
      label: 'Bausparkassen und sonstige Einlagenkreditinstitute',
    },
  ],
  [NONDEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP]: [
    {
      value: '52221',
      label: 'Ausgabe von Kreditkarten',
    },
    {
      value: '52222',
      label: 'Absatz- und Handelsfinanzierung',
    },
    {
      value: '522291',
      label: 'Konsumentenkredite',
    },
    {
      value: '522292',
      label: 'Immobilienkredite',
    },
    {
      value: '522299',
      label: 'Internationale, Sekundärmarkt- und sonstige nicht einlagenbasierte Kreditvermittlung',
    },
  ],
  [ACTIVITIES_RELATED_TO_CREDIT_INTERMEDIATION_INDUSTRY_GROUP]: [
    {
      value: '52231',
      label: 'Vermittlung von Hypotheken- und sonstigen Darlehen',
    },
    {
      value: '52232',
      label: 'Abwicklung von Finanztransaktionen, Reserve- und Clearinghausdienste',
    },
    {
      value: '52239',
      label: 'Sonstige Tätigkeiten im Zusammenhang mit der Kreditvermittlung',
    },
  ],
  [COMMODITY_CONTRACTS_INDUSTRY_GROUP]: [
    {
      value: '52315',
      label: 'Investmentbanking und Wertpapiervermittlung',
    },
    {
      value: '52316',
      label: 'Vermittlung von Warentermingeschäften',
    },
  ],
  [COMMODITY_EXCHANGES_INDUSTRY_GROUP]: [],
  [OTHER_FINANCIAL_INVESTMENT_ACTIVITIES_INDUSTRY_GROUP]: [
    {
      value: '52391',
      label: 'Sonstige Vermittlungsdienstleistungen',
    },
    {
      value: '52394',
      label: 'Portfolioverwaltung und Anlageberatung',
    },
    {
      value: '523991',
      label: 'Treuhand-, Verwahr- und Treuhandgeschäfte',
    },
    {
      value: '523999',
      label: 'Sonstige Finanzanlageaktivitäten',
    },
  ],
  [INSURANCE_CARRIER_INDUSTRY_GROUP]: [
    {
      value: '52411',
      label: 'Direktversicherer für Lebens-, Kranken- und medizinische Versicherungen',
    },
    {
      value: '524126',
      label: 'Direktversicherer für Sach- und Haftpflichtversicherungen',
    },
    {
      value: '524127',
      label: 'Direktversicherer für Titel- und Grundstücksrechtsversicherungen',
    },
    {
      value: '524128',
      label: 'Sonstige Direktversicherer (ohne Lebens-, Kranken- und medizinische Versicherungen)',
    },
    {
      value: '52413',
      label: 'Rückversicherer',
    },
  ],
  [AGENCIES_BROKERAGES_INDUSTRY_GROUP]: [
    {
      value: '52421',
      label: 'Versicherungsagenturen und -makler',
    },
    {
      value: '524291',
      label: 'Schadenregulierung',
    },
    {
      value: '524292',
      label: 'Verwaltung von Arzneimittelvergütungen und sonstige Drittverwaltung von Versicherungs- und Pensionsfonds',
    },
    {
      value: '524298',
      label: 'Sonstige versicherungsnahe Dienstleistungen',
    },
  ],
  [INSURANCE_FUNDS_INDUSTRY_GROUP]: [
    {
      value: '52511',
      label: 'Pensionsfonds',
    },
    {
      value: '52512',
      label: 'Gesundheits- und Fürsorgefonds',
    },
    {
      value: '52519',
      label: 'Sonstige Versicherungsfonds',
    },
  ],
  [OTHER_FUNDS_FUNDS_INDUSTRY_GROUP]: [
    {
      value: '52591',
      label: 'Offene Investmentfonds',
    },
    {
      value: '52592',
      label: 'Treuhandvermögen, Nachlässe und Treuhandkonten',
    },
    {
      value: '52599',
      label: 'Sonstige Finanzvehikel',
    },
  ],
  [LESSORS_OF_REAL_ESTATE_INDUSTRY_GROUP]: [
    {
      value: '53111',
      label: 'Vermieter von Wohngebäuden und Wohnungen',
    },
    {
      value: '53112',
      label: 'Vermieter von Nichtwohngebäuden (ohne Selfstorage-Anlagen)',
    },
    {
      value: '53113',
      label: 'Vermieter von Selfstorage- und Lagerbox-Anlagen',
    },
    {
      value: '53119',
      label: 'Vermieter sonstiger Immobilien',
    },
  ],
  [OFFICES_OF_REAL_ESTATE_INDUSTRY_GROUP]: [],
  [ACTIVITIES_RELATED_TO_REAL_ESTATE_INDUSTRY_GROUP]: [
    {
      value: '53131',
      label: 'Immobilienverwalter',
    },
    {
      value: '53132',
      label: 'Büros von Immobiliengutachtern',
    },
    {
      value: '53139',
      label: 'Sonstige immobilienbezogene Dienstleistungen',
    },
  ],
  [AUTOMOTIVE_LEASING_INDUSTRY_GROUP]: [
    {
      value: '53211',
      label: 'Vermietung und Leasing von Pkw',
    },
    {
      value: '53212',
      label: 'Vermietung und Leasing von Lkw, Anhängern und Freizeitfahrzeugen',
    },
  ],
  [CONSUMER_GOODS_RENTAL_INDUSTRY_GROUP]: [
    {
      value: '53221',
      label: 'Vermietung von Unterhaltungselektronik und Haushaltsgeräten',
    },
    {
      value: '532281',
      label: 'Vermietung von Festkleidung und Kostümen',
    },
    {
      value: '532282',
      label: 'Vermietung von Videoaufnahmen und Datenträgern',
    },
    {
      value: '532283',
      label: 'Vermietung von medizinischen Hilfsmitteln für die häusliche Pflege',
    },
    {
      value: '532284',
      label: 'Vermietung von Freizeit- und Sportgeräten',
    },
    {
      value: '532289',
      label: 'Vermietung sonstiger Konsumgüter',
    },
  ],
  [GENERAL_RENTAL_CENTERS_INDUSTRY_GROUP]: [],
  [COMMERCIAL_MACHINERY_INDUSTRY_GROUP]: [
    {
      value: '532411',
      label: 'Vermietung und Leasing von Luft-, Schienen- und Wasserverkehrsausrüstung',
    },
    {
      value: '532412',
      label: 'Vermietung und Leasing von Bau-, Bergbau- und Forstmaschinen',
    },
    {
      value: '53242',
      label: 'Vermietung und Leasing von Bürogeräten und -maschinen',
    },
    {
      value: '53249',
      label: 'Vermietung und Leasing sonstiger gewerblicher und industrieller Maschinen und Ausrüstungen',
    },
  ],
  [LEGAL_SERVICES_INDUSTRY_GROUP]: [
    { value: '54111', label: 'Anwaltskanzleien' },
    { value: '54112', label: 'Notariatsbüros' },
    { value: '541191', label: 'Büros für Grundbuchauszüge und Abschlussdienstleistungen' },
    { value: '541199', label: 'Alle übrigen juristischen Dienstleistungen' },
  ],
  [ACCOUNTING_SERVICES_INDUSTRY_GROUP]: [
    { value: '541211', label: 'Büros vereidigter Wirtschaftsprüfer' },
    { value: '541213', label: 'Steuerberatung' },
    { value: '541214', label: 'Lohn- und Gehaltsabrechnungsdienste' },
    { value: '541219', label: 'Alle übrigen Buchhaltungsdienste' },
  ],
  [ARCHITECTURAL_SERVICES_INDUSTRY_GROUP]: [
    { value: '54131', label: 'Architekturdienstleistungen' },
    { value: '54132', label: 'Landschaftsarchitektur' },
    { value: '54133', label: 'Ingenieurdienstleistungen' },
    { value: '54134', label: 'Zeichnungsdienste' },
    { value: '54135', label: 'Bauinspektionsdienste' },
    { value: '54136', label: 'Geophysikalische Vermessungs- und Kartierungsdienste' },
    { value: '54137', label: 'Vermessungs- und Kartierungsdienste (außer geophysikalisch)' },
    { value: '54138', label: 'Prüflabore und -dienstleistungen' },
  ],
  [DESIGN_SERVICES_INDUSTRY_GROUP]: [
    { value: '54141', label: 'Innendesign-Dienstleistungen' },
    { value: '54142', label: 'Industriedesign-Dienstleistungen' },
    { value: '54143', label: 'Grafikdesign-Dienstleistungen' },
    { value: '54149', label: 'Sonstige spezialisierte Design-Dienstleistungen' },
  ],
  [COMPUTER_SYSTEMS_DESIGN_SERVICES_INDUSTRY_GROUP]: [
    { value: '541511', label: 'Kundenspezifische Softwareprogrammierung' },
    { value: '541512', label: 'IT-Systemdesign-Dienstleistungen' },
    { value: '541513', label: 'IT-Infrastruktur- und Rechenzentrumsmanagement' },
    { value: '541519', label: 'Sonstige computerbezogene Dienstleistungen' },
  ],
  [TECHNICAL_CONSULTING_SERVICES_INDUSTRY_GROUP]: [
    { value: '541611', label: 'Unternehmens- und Verwaltungsberatung' },
    { value: '541612', label: 'HR- und Personalberatungsdienste' },
    { value: '541613', label: 'Marketingberatung' },
    { value: '541614', label: 'Beratung in Logistik, physischer Distribution und Prozessmanagement' },
    { value: '541618', label: 'Sonstige Managementberatungsdienste' },
    { value: '54162', label: 'Umweltberatungsdienste' },
    { value: '54169', label: 'Sonstige wissenschaftliche und technische Beratungsdienste' },
  ],
  [SCIENTIFIC_RESEARCH_SERVICES_INDUSTRY_GROUP]: [
    { value: '541713', label: 'Forschung und Entwicklung in der Nanotechnologie' },
    { value: '541714', label: 'Forschung und Entwicklung in der Biotechnologie (ohne Nanobiotechnologie)' },
    {
      value: '541715',
      label:
        'Forschung und Entwicklung in den physikalischen, technischen und Lebenswissenschaften (ohne Nano- und Biotechnologie)',
    },
    { value: '54172', label: 'Forschung und Entwicklung in Sozial- und Geisteswissenschaften' },
  ],
  [ADVERTISING_SERVICES_INDUSTRY_GROUP]: [
    { value: '54181', label: 'Werbeagenturen' },
    { value: '54182', label: 'Public-Relations-Agenturen' },
    { value: '54183', label: 'Media-Einkaufsagenturen' },
    { value: '54184', label: 'Medienvertreter' },
    { value: '54185', label: 'Innen- und Außenwerbung' },
    { value: '54186', label: 'Direktmailing-Werbung' },
    { value: '54187', label: 'Verteilung von Werbematerial' },
    { value: '54189', label: 'Sonstige werbebezogene Dienstleistungen' },
  ],
  [OTHER_TECHNICAL_SERVICES_INDUSTRY_GROUP]: [
    { value: '54191', label: 'Marktforschung und Meinungsumfragen' },
    { value: '54192', label: 'Fotodienstleistungen' },
    { value: '54193', label: 'Übersetzungs- und Dolmetschdienste' },
    { value: '54194', label: 'Tierärztliche Dienste' },
    { value: '54199', label: 'Alle übrigen professionellen, wissenschaftlichen und technischen Dienstleistungen' },
  ],
  [EMPLOYMENTS_SERVICES_INDUSTRY_GROUP]: [
    { value: '561311', label: 'Arbeitsvermittlungsagenturen' },
    { value: '561312', label: 'Executive-Search-Dienste' },
    { value: '56132', label: 'Zeitarbeitsdienste' },
    { value: '56133', label: 'Professionelle Arbeitgeberorganisationen' },
  ],
  [BUSINESS_SUPPORT_SERVICES_INDUSTRY_GROUP]: [
    { value: '56141', label: 'Dokumentenbearbeitungsdienste' },
    { value: '56142', label: 'Telefon-Callcenter' },
    { value: '56143', label: 'Business-Service-Center' },
    { value: '561431', label: 'Private Poststellen' },
    { value: '561439', label: 'Sonstige Business-Service-Center (inkl. Copyshops)' },
    { value: '56144', label: 'Inkassounternehmen' },
    { value: '56145', label: 'Auskunfteien' },
    { value: '561491', label: 'Rückführungsdienste' },
    { value: '561492', label: 'Gerichtsreporter- und Stenografiedienste' },
    { value: '561499', label: 'Alle übrigen Business-Support-Dienstleistungen' },
  ],
  [RESERVATION_SERVICES_INDUSTRY_GROUP]: [
    { value: '56151', label: 'Reisebüros' },
    { value: '56152', label: 'Reiseveranstalter' },
    { value: '56159', label: 'Sonstige Reservierungs- und Reiseorganisationsdienste' },
  ],
  [INVESTIGATION_AND_SECURITY_SERVICES_INDUSTRY_GROUP]: [
    { value: '561611', label: 'Ermittlungs- und Hintergrundprüfungsdienste' },
    { value: '561612', label: 'Sicherheits- und Wachschutzdienste' },
    { value: '561613', label: 'Geld- und Werttransporte' },
    { value: '56162', label: 'Sicherheitsanlagendienste' },
  ],
  [SERVICES_TO_BUILDINGS_INDUSTRY_GROUP]: [
    { value: '56171', label: 'Schädlingsbekämpfungsdienste' },
    { value: '56172', label: 'Reinigungsdienste' },
    { value: '56173', label: 'Landschaftspflege' },
    { value: '56174', label: 'Teppich- und Polsterreinigung' },
    { value: '56179', label: 'Sonstige Dienstleistungen für Gebäude und Haushalte' },
  ],
  [OTHER_SUPPORT_SERVICES_INDUSTRY_GROUP]: [
    { value: '56191', label: 'Verpackungs- und Etikettierungsdienste' },
    { value: '56192', label: 'Messen- und Ausstellungsorganisation' },
    { value: '56199', label: 'Alle übrigen Unterstützungsdienste' },
  ],
  [WASTE_COLLECTION_INDUSTRY_GROUP]: [
    { value: '562111', label: 'Sammeln von Siedlungsabfällen' },
    { value: '562112', label: 'Sammeln von gefährlichen Abfällen' },
    { value: '562119', label: 'Sonstige Abfallsammlung' },
  ],
  [WASTE_DISPOSAL_INDUSTRY_GROUP]: [
    { value: '562211', label: 'Behandlung und Entsorgung gefährlicher Abfälle' },
    { value: '562212', label: 'Deponien für Siedlungsabfälle' },
    { value: '562213', label: 'Verbrennung und Müllverbrennungsanlagen' },
    { value: '562219', label: 'Sonstige Behandlung nicht gefährlicher Abfälle' },
  ],
  [REMEDIATION_AND_OTHER_WASTE_MANAGEMENT_SERVICE_INDUSTRY_GROUP]: [
    { value: '56291', label: 'Sanierungsdienste' },
    { value: '56292', label: 'Materialrückgewinnungsanlagen' },
    { value: '56299', label: 'Alle übrigen Abfallwirtschaftsdienste' },
    { value: '562991', label: 'Fäkalien- und Abwasserpumpdienste' },
    { value: '562998', label: 'Sonstige Abfallentsorgungsdienste' },
  ],

  [ELEMENTARY_SCHOOLS_INDUSTRY_GROUP]: [],
  [JUNIOR_COLLEGES_INDUSTRY_GROUP]: [],
  [PROFESSIONAL_SCHOOLS_INDUSTRY_GROUP]: [],
  [BUSINESS_SCHOOLS_INDUSTRY_GROUP]: [
    { value: '61141', label: 'Wirtschafts- und Sekretariatsschulen' },
    { value: '61142', label: 'Computerschulungen' },
    { value: '61143', label: 'Schulungen für berufliche und Management-Weiterentwicklung' },
  ],
  [TRADE_SCHOOLS_INDUSTRY_GROUP]: [
    { value: '611511', label: 'Schulen für Kosmetik und Friseurhandwerk' },
    { value: '611512', label: 'Flugschulen' },
    { value: '611513', label: 'Ausbildungszentren für Lehrberufe' },
    { value: '611519', label: 'Sonstige technische und berufsbildende Schulen' },
  ],
  [OTHER_SCHOOLS_INDUSTRY_GROUP]: [
    { value: '61161', label: 'Schulen für bildende und darstellende Kunst' },
    { value: '61162', label: 'Unterricht in Sport und Freizeitaktivitäten' },
    { value: '61163', label: 'Sprachschulen' },
    { value: '61169', label: 'Alle übrigen Schulen und Unterrichtsdienstleistungen' },
    { value: '611691', label: 'Prüfungsvorbereitung und Nachhilfe' },
    { value: '611692', label: 'Fahrschulen' },
    { value: '611699', label: 'Alle sonstigen verschiedenen Schulen und Unterricht' },
  ],
  [EDUCATIONAL_SUPPORT_SERVICES_INDUSTRY_GROUP]: [],
  [PHYSICIANS_INDUSTRY_GROUP]: [
    { value: '621111', label: 'Arztpraxen (ohne Fachärzte für psychische Gesundheit)' },
    { value: '621112', label: 'Praxen von Fachärzten für psychische Gesundheit' },
  ],
  [DENTISTS_INDUSTRY_GROUP]: [],
  [OTHER_HEALTH_PRACTITIONERS_INDUSTRY_GROUP]: [
    { value: '62131', label: 'Praxen von Chiropraktikern' },
    { value: '62132', label: 'Praxen von Optometristen' },
    { value: '62133', label: 'Praxen sonstiger Fachkräfte für psychische Gesundheit (ohne Ärzte)' },
    {
      value: '62134',
      label: 'Praxen für Physio-, Ergo-, Sprachtherapie und Audiologie',
    },
    { value: '621391', label: 'Praxen von Podologen' },
    { value: '621399', label: 'Praxen sonstiger Gesundheitsdienstleister' },
  ],
  [OUTPATIENT_CARE_CENTERS_INDUSTRY_GROUP]: [
    { value: '61141', label: 'Zentren für Familienplanung' },
    { value: '61142', label: 'Ambulante Zentren für psychische Gesundheit und Suchtbehandlung' },
    { value: '61149', label: 'Sonstige ambulante Behandlungszentren' },
  ],
  [MEDICAL_LABS_INDUSTRY_GROUP]: [
    { value: '621511', label: 'Medizinische Laboratorien' },
    { value: '621512', label: 'Diagnostische Bildgebungszentren' },
  ],
  [HOME_HEALTH_CARE_SERVICES_INDUSTRY_GROUP]: [],
  [OTHER_AMBULATORY_HEALTH_CARE_INDUSTRY_GROUP]: [
    { value: '62191', label: 'Rettungs- und Krankentransportdienste' },
    { value: '621991', label: 'Blut- und Organspendedienste' },
    { value: '621999', label: 'Alle übrigen ambulanten Gesundheitsdienste' },
  ],
  [GENERAL_MEDICAL_INDUSTRY_GROUP]: [],
  [SUBSTANCE_ABUSE_HOSPITALS_INDUSTRY_GROUP]: [],
  [SPECIALTY_HOSPITALS__INDUSTRY_GROUP]: [],
  [NURSING_CARE_FACILITIES_INDUSTRY_GROUP]: [],
  [RESIDENTIAL_INTELLECTUAL_INDUSTRY_GROUP]: [
    {
      value: '62321',
      label: 'Stationäre Einrichtungen für Menschen mit geistigen und Entwicklungsbehinderungen',
    },
    {
      value: '62322',
      label: 'Stationäre Einrichtungen für psychische Erkrankungen und Suchterkrankungen',
    },
  ],
  [RETIREMENT_COMMUNITIES_INDUSTRY_GROUP]: [
    {
      value: '623311',
      label: 'Stationäre Einrichtungen für psychische Erkrankungen und Suchterkrankungen',
    },
    { value: '623312', label: 'Betreute Wohneinrichtungen für Senioren' },
  ],
  [OTHER_RESIDENTIAL_CARE_INDUSTRY_GROUP]: [],
  [INDIVIDUAL_AND_FAMILY_SERVICES_INDUSTRY_GROUP]: [
    { value: '62411', label: 'Dienste für Kinder und Jugendliche' },
    {
      value: '62412',
      label: 'Dienste für Senioren und Menschen mit Behinderungen',
    },
    { value: '62419', label: 'Sonstige individuelle und familienbezogene Dienste' },
  ],
  [OTHER_RELIEF_SERVICES_INDUSTRY_GROUP]: [
    { value: '62421', label: 'Gemeinschaftliche Lebensmittelausgabestellen' },
    { value: '62422', label: 'Gemeinnützige Wohnungsdienste' },
    { value: '62423', label: 'Not- und sonstige Hilfsdienste' },
  ],
  [VOCATIONAL_REHABILITATION_SERVICES_INDUSTRY_GROUP]: [],
  [CHILD_CARE_SERVICES_INDUSTRY_GROUP]: [],
  [PERFORMING_ARTS_COMPANIES_INDUSTRY_GROUP]: [
    { value: '71111', label: 'Theaterensembles und Dinner-Theater' },
    { value: '71112', label: 'Tanzensembles' },
    { value: '71113', label: 'Musikgruppen und -künstler' },
    { value: '71119', label: 'Sonstige darstellende Kunstensembles' },
  ],
  [SPECTATOR_SPORTS_INDUSTRY_GROUP]: [
    { value: '711211', label: 'Sportmannschaften und -vereine' },
    { value: '711212', label: 'Rennbahnen' },
    { value: '711219', label: 'Sonstige Zuschauersportarten' },
  ],
  [PROMOTERS_OF_PERFORMING_ARTS_INDUSTRY_GROUP]: [
    {
      value: '71131',
      label: 'Veranstalter von Darstellender Kunst, Sport u. Ä. mit eigenen Veranstaltungsstätten',
    },
    {
      value: '71132',
      label: 'Veranstalter von Darstellender Kunst, Sport u. Ä. ohne eigene Veranstaltungsstätten',
    },
  ],
  [ARTISTS_AGENTS_AND_MANAGERS_INDUSTRY_GROUP]: [],
  [INDEPENDENT_ARTISTS_INDUSTRY_GROUP]: [],
  [AMUSEMENT_PARKS_INDUSTRY_GROUP]: [
    { value: '71311', label: 'Freizeit- und Themenparks' },
    { value: '71312', label: 'Spiel- und Unterhaltungsarkaden' },
  ],
  [GAMBLING_INDUSTRIES_INDUSTRY_GROUP]: [
    { value: '71321', label: 'Kasinos (ohne Kasinohotels)' },
    { value: '71329', label: 'Sonstige Glücksspielunternehmen' },
  ],
  [OTHER_AMUSEMENT_INDUSTRY_GROUP]: [
    { value: '71391', label: 'Golfplätze und Country Clubs' },
    { value: '71392', label: 'Skigebiete' },
    { value: '71393', label: 'Yachthäfen' },
    { value: '71394', label: 'Fitness- und Freizeitsportzentren' },
    { value: '71395', label: 'Bowlingbahnen' },
    { value: '71399', label: 'Alle übrigen Freizeit- und Vergnügungsbetriebe' },
  ],
  [TRAVELER_ACCOMMODATION_INDUSTRY_GROUP]: [
    { value: '72111', label: 'Hotels (ohne Kasinohotels) und Motels' },
    { value: '72112', label: 'Kasinohotels' },
    { value: '72119', label: 'Sonstige Unterkünfte für Reisende' },
    { value: '721191', label: 'Bed-and-Breakfast-Pensionen' },
    { value: '721199', label: 'Alle übrigen Unterkünfte für Reisende' },
  ],
  [RECREATIONAL_CAMPS_INDUSTRY_GROUP]: [
    { value: '721211', label: 'Wohnmobilstellplätze und Campingplätze' },
    { value: '721214', label: 'Freizeit- und Ferienlager (ohne Campingplätze)' },
  ],
  [WORKERS_CAMPS_INDUSTRY_GROUP]: [],
  [SPECIAL_FOOD_SERVICES_INDUSTRY_GROUP]: [
    { value: '72231', label: 'Gemeinschaftsverpflegungsdienstleister' },
    { value: '72232', label: 'Caterer' },
    { value: '72233', label: 'Mobile Imbiss- und Speisenanbieter' },
  ],
  [DRINKING_PLACES_INDUSTRY_GROUP]: [],
  [OTHER_EATING_PLACES_INDUSTRY_GROUP]: [
    { value: '722511', label: 'Bedienrestaurants' },
    { value: '722513', label: 'Schnellrestaurants' },
    {
      value: '722514',
      label: 'Cafeterien, Grill- und Buffetrestaurants',
    },
    { value: '722515', label: 'Snackbars und alkoholfreie Getränkebars' },
  ],
  [AUTOMOTIVE_REPAIR_INDUSTRY_GROUP]: [
    { value: '811111', label: 'Allgemeine Kfz-Reparatur' },
    { value: '811114', label: 'Spezialisierte Kfz-Reparatur' },
    {
      value: '811121',
      label: 'Karosserie-, Lack- und Innenraumreparatur und -wartung für Kfz',
    },
    { value: '811122', label: 'Kfz-Scheibenaustauschbetriebe' },
    { value: '811191', label: 'Kfz-Ölwechsel- und Schmierdienste' },
    { value: '811192', label: 'Autowaschanlagen' },
    { value: '811198', label: 'Alle übrigen Kfz-Reparatur- und Wartungsdienste' },
  ],
  [ELECTRONICS_REPAIR_INDUSTRY_GROUP]: [],
  [COMMERCIAL_REPAIR_AND_MAINTENANCE_INDUSTRY_GROUP]: [],
  [PERSONAL_GOODS_REPAIR_INDUSTRY_GROUP]: [
    {
      value: '811411',
      label: 'Reparatur und Wartung von Haus- und Gartengeräten',
    },
    { value: '811412', label: 'Reparatur und Wartung von Haushaltsgeräten' },
    { value: '81142', label: 'Polsterei und Möbelreparatur' },
    { value: '81143', label: 'Reparatur von Schuhen und Lederwaren' },
    {
      value: '81149',
      label: 'Reparatur und Wartung sonstiger persönlicher und Haushaltsgüter',
    },
  ],
  [PERSONAL_CARE_SERVICES_INDUSTRY_GROUP]: [
    { value: '812111', label: 'Barbershops' },
    { value: '812112', label: 'Kosmetiksalons' },
    { value: '812113', label: 'Nagelstudios' },
    { value: '81219', label: 'Sonstige Körperpflege-Dienstleistungen' },
    { value: '812191', label: 'Ernährungs- und Gewichtsreduktionszentren' },
  ],
  [DEATH_CARE_SERVICES_INDUSTRY_GROUP]: [
    { value: '81221', label: 'Bestattungshäuser und Bestattungsdienste' },
    { value: '81222', label: 'Friedhöfe und Krematorien' },
  ],
  [LAUNDRY_SERVICES_INDUSTRY_GROUP]: [
    {
      value: '81231',
      label: 'Münzbetriebene Waschsalons und Reinigungen',
    },
    {
      value: '81232',
      label: 'Chemische Reinigungen und Wäschereien (ohne Münzbetrieb)',
    },
    { value: '812331', label: 'Wäscheversorgungsdienste' },
    { value: '812332', label: 'Industrielle Wäschereien' },
  ],
  [OTHER_PERSONAL_SERVICES_INDUSTRY_GROUP]: [
    {
      value: '81291',
      label: 'Tierbetreuungsdienste (ohne tierärztliche Leistungen)',
    },
    { value: '81292', label: 'Fotofinishing-Dienste' },
    { value: '81293', label: 'Parkplätze und Parkhäuser' },
    { value: '81299', label: 'Alle übrigen personenbezogenen Dienstleistungen' },
  ],
  [RELIGIOUS_ORGANIZATIONS_INDUSTRY_GROUP]: [],
  [GRANTMAKING_INDUSTRY_GROUP]: [
    { value: '813211', label: 'Förderstiftungen' },
    { value: '813212', label: 'Gemeinnützige Gesundheitsorganisationen' },
    { value: '813219', label: 'Sonstige Stiftungs- und Spendenorganisationen' },
  ],
  [SOCIAL_ADVOCACY_INDUSTRY_GROUP]: [
    { value: '813311', label: 'Menschenrechtsorganisationen' },
    {
      value: '813312',
      label: 'Umwelt-, Natur- und Tierschutzorganisationen',
    },
    { value: '813319', label: 'Sonstige sozialpolitische Interessenorganisationen' },
  ],
  [SOCIAL_ORGANIZATIONS_INDUSTRY_GROUP]: [],
  [BUSINESS_LABOR_POLITICAL_INDUSTRY_GROUP]: [
    { value: '81391', label: 'Wirtschaftsverbände' },
    { value: '81392', label: 'Berufsverbände' },
    { value: '81393', label: 'Gewerkschaften und ähnliche Arbeitnehmerorganisationen' },
    { value: '81394', label: 'Politische Organisationen' },
    {
      value: '81399',
      label:
        'Sonstige ähnliche Organisationen (ohne Wirtschafts-, Berufs-, Gewerkschafts- oder politische Organisationen)',
    },
  ],
  [MANAGEMENT_OF_COMPANIES_SECTOR]: [
    { value: '551111', label: 'Verwaltungssitze von Bankholdinggesellschaften' },
    { value: '551112', label: 'Verwaltungssitze sonstiger Holdinggesellschaften' },
    { value: '551114', label: 'Konzern-, Tochter- und regionale Verwaltungszentralen' },
  ],
  [RAIL_TRANSPORTATION_SUB_SECTOR]: [
    { value: '482111', label: 'Fernbahnen' },
    { value: '482112', label: 'Kurzstreckenbahnen' },
  ],
  [POSTAL_SERVICE_SUB_SECTOR]: [],
  [WAREHOUSING_AND_STORAGE_SUB_SECTOR]: [
    { value: '49311', label: 'Allgemeine Lagerhaltung und -speicherung' },
    { value: '49312', label: 'Tiefkühl- und Kühlhäuser' },
    { value: '49313', label: 'Lagerung von Agrarerzeugnissen' },
    { value: '49319', label: 'Sonstige Lagerhaltung und -speicherung' },
  ],
  [COMPUTING_INFRASTRUCTURE_SUB_SECTOR]: [],
  [WEB_SEARCH_PORTALS_SUB_SECTOR]: [
    { value: '51921', label: 'Bibliotheken und Archive' },
    {
      value: '51929',
      label: 'Web-Suchportale und alle übrigen Informationsdienste',
    },
  ],
  [MONETARY_BANK_SUB_SECTOR]: [],
  [LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR]: [],
  [MUSEUMS_SUB_SECTOR]: [
    { value: '71211', label: 'Museen' },
    { value: '71212', label: 'Historische Stätten' },
    { value: '71213', label: 'Zoos und Botanische Gärten' },
    { value: '71219', label: 'Naturparks und ähnliche Einrichtungen' },
  ],
  [PRIVATE_HOUSEHOLDS_SUB_SECTOR]: [],
  [EXECUTIVE_LEGISLATIVE_SUB_SECTOR]: [
    { value: '92111', label: 'Exekutivbehörden' },
    { value: '92112', label: 'Legislativorgane' },
    { value: '92113', label: 'Öffentliche Finanzverwaltung' },
    { value: '92114', label: 'Gemeinsame Exekutiv- und Legislativbehörden' },
    {
      value: '92115',
      label: 'Stammesregierungen der amerikanischen Ureinwohner und Ureinwohner Alaskas',
    },
    { value: '92119', label: 'Sonstige allgemeine Regierungsunterstützung' },
  ],
  [JUSTICE_PUBLIC_ORDER_SUB_SECTOR]: [
    { value: '92211', label: 'Gerichte' },
    { value: '92212', label: 'Polizeidienst' },
    { value: '92213', label: 'Rechtsberatung und Strafverfolgung' },
    { value: '92214', label: 'Justizvollzugsanstalten' },
    { value: '92215', label: 'Bewährungs- und Haftentlassungsdienste' },
    { value: '92216', label: 'Feuerwehr- und Brandschutzdienste' },
    {
      value: '92219',
      label: 'Sonstige Tätigkeiten in Justiz, öffentlicher Ordnung und Sicherheit',
    },
  ],
  [ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR]: [
    { value: '92311', label: 'Verwaltung von Bildungsprogrammen' },
    { value: '92312', label: 'Verwaltung öffentlicher Gesundheitsprogramme' },
    {
      value: '92313',
      label: 'Verwaltung sozialer Programme (ohne Bildung, öffentliche Gesundheit und Veteranenprogramme)',
    },
    { value: '92314', label: 'Verwaltung von Veteranenangelegenheiten' },
  ],
  [ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR]: [
    {
      value: '92411',
      label: 'Verwaltung von Programmen für Luft- und Wasserressourcen sowie Abfallwirtschaft',
    },
    { value: '92412', label: 'Verwaltung von Naturschutzprogrammen' },
  ],
  [ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR]: [
    { value: '92511', label: 'Verwaltung von Wohnungsbauprogrammen' },
    {
      value: '92512',
      label: 'Verwaltung von Stadtplanung sowie Gemeinde- und Regionalentwicklung',
    },
  ],
  [ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR]: [
    { value: '92611', label: 'Verwaltung allgemeiner Wirtschaftsprogramme' },
    {
      value: '92612',
      label: 'Regulierung und Verwaltung von Verkehrsprogrammen',
    },
    {
      value: '92613',
      label: 'Regulierung und Verwaltung von Kommunikations-, Strom-, Gas- und sonstigen Versorgungsprogrammen',
    },
    {
      value: '92614',
      label: 'Regulierung des Agrarmarketings und von Agrarrohstoffen',
    },
    {
      value: '92615',
      label: 'Regulierung, Lizenzierung und Überwachung sonstiger Wirtschaftssektoren',
    },
  ],
  [SPACE_RESEARCH_SUB_SECTOR]: [],
  [NATIONAL_SECURITY_SUB_SECTOR]: [
    { value: '92811', label: 'Nationale Sicherheit' },
    { value: '92812', label: 'Internationale Angelegenheiten' },
  ],
};
